import axios from 'axios';
import styles from '../styles/auth/AuthLayout.module.scss';
import type { AxiosError, AxiosResponse } from 'axios';
import { API_URL,GET_ALL_DESIGNACAO_ACAO, GET_INT_COMPONENTE, GET_INT_INDICADOR, AUTH_LOCALSTORAGE, BASE_GEOPORTAL_URL, GET_AG_DECISOES, GET_AG_ESTADOS, GET_AG_TEMA, GET_AG_TIPO_PRETENSOES, GET_CODIGO_INTERVENCAO, GET_CONCELHO_FROM_CODE, GET_DESIGNACAO_INTERVENCAO, GET_DH_RECONHECIMENTO_PROPRIEDADE_PRIVADA, PESQUISAR_TIPO_RECURSO, GET_DH_TIPO_ACAO_RECONHECIMENTOS, GET_DH_TIPO_DOMINIO, GET_DISTRITO_FROM_CODE, GET_EA_ESTADO, GET_ENTIDADE, GET_ENTIDADE_BY_USER, GET_ESTADOS_OCORRENCIA, GET_FREGUESIA_FROM_CODE, GET_MO_ESTADOS, GET_NUTS_3_FROM_CODE, GET_PROCESSOS_MARCACOES, GET_PROCESSOS_PARECERES, GET_TECNICOS, GET_TIPO_INCIDENCIA, GET_TIPO_TITULOS, GET_USER_BY_ID, GET_US_COMPONENTE_VUS, GET_US_ESTADO_TITULO, GET_US_ESTADO_VUS, GET_US_FONTE_DADOS_VUS, GET_US_TIPO_UTILIZACAO, GET_US_TIPO_VUS, GET_US_VUS, NOT_AUTHORIZED_ERROR_STATUS_CODE, PASS_GUEST, PERMISSION_ERROR_STATUS_CODE, PESQUISAR_ACAO_ESTADO, PESQUISAR_ACAO_NATUREZA, PESQUISAR_ACAO_PLANEAMENTO1, PESQUISAR_ACAO_PLANEAMENTO2, PESQUISAR_ACAO_PLANEAMENTO3, PESQUISAR_ACAO_PLANEAMENTO4, PESQUISAR_ARHS, PESQUISAR_CAPTANIA, PESQUISAR_CATEGORIA, PESQUISAR_COMPONENTE_ACAO, PESQUISAR_CONCELHOS, PESQUISAR_CONDICIONANTES_PROCESSO, PESQUISAR_DEPOSICAO_LOCAL_NIVEL1, PESQUISAR_DEPOSICAO_LOCAL_NIVEl2, PESQUISAR_DEPOSICAO_OBJETIVO_NIVEL1, PESQUISAR_DEPOSICAO_OBJETIVO_NIVEL2, PESQUISAR_DISTRITOS, PESQUISAR_ENTIDADES, PESQUISAR_ESTADO, PESQUISAR_ESTADO_CANDIDATURA, PESQUISAR_ESTADO_INTERVENCOES, PESQUISAR_ESTADO_PROCESSO, PESQUISAR_FASE_PROCEDIMENTO_DE_ELIMINACAO, PESQUISAR_FREGUESIAS, PESQUISAR_FUNCAO, PESQUISAR_GRANULAMETRIA_SEDIMENTOS, PESQUISAR_IDIOMA, PESQUISAR_INSTRUMENTO_FINANCIAMENTO, PESQUISAR_INSTRUMENTO_PLANEAMENTO, PESQUISAR_LOCALIZACAO_PROCESSO, PESQUISAR_MANCHA_NIVEL1, PESQUISAR_MANCHA_NIVEL2, PESQUISAR_MASSADAGUA, PESQUISAR_METODO_DEPOSICAO, PESQUISAR_METODO_DRAGAGEM, PESQUISAR_MOBILIZACAO_ESTADO, PESQUISAR_MOBILIZACAO_FUNCOES, PESQUISAR_MOBILIZACAO_TIPOLOGIA, PESQUISAR_MOBILIZACOES_ESTADOS, PESQUISAR_MO_MODELO_SUBTIPOS, PESQUISAR_MO_MODELO_TIPOS, PESQUISAR_NUTS1, PESQUISAR_NUTS2, PESQUISAR_NUTS3, PESQUISAR_PALAVRACHAVE, PESQUISAR_PLANEAMENTO1, PESQUISAR_PLANEAMENTO2, PESQUISAR_PLANEAMENTO3, PESQUISAR_PRAIAS, PESQUISAR_PRIORIDADE, PESQUISAR_QUALIDADE_SEDIMENTOS, PESQUISAR_TIPOACESSO, PESQUISAR_TIPOENTIDADE, PESQUISAR_TIPOLOGIA_MOB, PESQUISAR_TIPORECURSO, PESQUISAR_TIPO_AQUISICAO, PESQUISAR_TIPO_DECISAO_FINAL, PESQUISAR_TIPO_DESAFETACAO, PESQUISAR_TIPO_ENGENHARIA, PESQUISAR_TIPO_INICIATIVA, PESQUISAR_TIPO_JUDICIAL, PESQUISAR_TIPO_NOTIFICACAO, PESQUISAR_TIPO_PARCELA, PESQUISAR_TIPO_PENDENCIA, PESQUISAR_TIPO_PLANEAMENTO, PESQUISAR_TIPO_PROCESSO, PESQUISAR_TIPO_SENTENCA, PESQUISAR_TIPO_SITUACAO_NOTIFICACAO, PESQUISAR_TIP_ENGENHARIA, PESQUISAR_TIP_NIVEL1, PESQUISAR_TIP_NIVEL2, PESQUISAR_TIP_NIVEL3, PESQUISAR_US_TIPO_PROCESSO, PESQUISAR_VALIDACAO_PROVA, URL_FONT_GRID_PDF, USER_GUEST, VZ_ESTADO, scalePDF, PESQUISAR_DEF_LICENCIAMENTO, GET_ASYNC_PROC_CONTRATACAO, GET_CODIGO_CANDIDATURA, GET_ASYNC_PRIORIDADE_PAL_XXI, GET_INT_TIPO_MOBILIZACAO, GET_TIPO_LINHA_DEMARCACAO, PESQUISAR_MODELO_ESTADO, IS_GEOM_POLYGON_VALID, IS_GEOM_LINE_VALID, GET_ALL_TIPO_TITULO, GET_SEARCH_LIMIT, PESQUISAR_ACAO_ESTADO_POR_PERFIL, PESQUISAR_MOBILIZACAO_ESTADO_POR_PERFIL, GET_TIPO_ACESSO_POR_PERFIL } from '../utils/constants';

import { useState } from 'react';
import { create } from 'zustand';
import SessionStorageService from './SessionStorageService';
import { Group, drawDOM, exportPDF } from '@progress/kendo-drawing';
import { defineFont } from '@progress/kendo-drawing/pdf';
import { base64ApaImage, base64FooterImages, base64SiarlImage } from '../routes/Base64Images';
import * as XLSX from 'xlsx';

type Method = 'get' | 'post' | 'put' | 'patch' | 'delete'

const GetAbpUsers = async (id: any) =>await get<any, any>(`${GET_USER_BY_ID}/${id}`)
const getEntidadeUser = async (id: any) => await get<any, any>(`${GET_ENTIDADE}/` + id)
const getDistritos = async () => await get<any>(`${PESQUISAR_DISTRITOS}`);
const getFreguesias = async () => await get<any>(`${PESQUISAR_FREGUESIAS}`);
const getConcelhos = async () => await get<any>(`${PESQUISAR_CONCELHOS}`);
const getArhs = async () => await get<any>(`${PESQUISAR_ARHS}`);
const getPraias = async () => await get<any>(`${PESQUISAR_PRAIAS}`);
const getNuts1 = async () => await get<any>(`${PESQUISAR_NUTS1}`);
const getNuts2 = async () => await get<any>(`${PESQUISAR_NUTS2}`);
const getNuts3 = async () => await get<any>(`${PESQUISAR_NUTS3}`);
const getTipoTitulos = async () => await get<any>(`${GET_TIPO_TITULOS}`);
const getAllTipoTitulos = async () => await get<any>(`${GET_ALL_TIPO_TITULO}`);
//INTERVENCOES
const getNaturezaAcao = async () => await get<any>(`${PESQUISAR_ACAO_NATUREZA}`);
const getTipoPlaneamento = async () => await get<any>(`${PESQUISAR_TIPO_PLANEAMENTO}`);
const getTipoEngenharia = async () => await get<any>(`${PESQUISAR_TIPO_ENGENHARIA}`);
const getTipNivel1 = async () => await get<any>(`${PESQUISAR_TIP_NIVEL1}`);
const getTipNivel2 = async () => await get<any>(`${PESQUISAR_TIP_NIVEL2}`);
const getTipNivel3 = async () => await get<any>(`${PESQUISAR_TIP_NIVEL3}`);
const getPrioridade = async () => await get<any>(`${PESQUISAR_PRIORIDADE}`);
const getPrioridadePalXXI = async () => await get<any>(`${GET_ASYNC_PRIORIDADE_PAL_XXI}`);
const getTipEngenharia = async () => await get<any>(`${PESQUISAR_TIP_ENGENHARIA}`);
const getManchaNivel1 = async () => await get<any>(`${PESQUISAR_MANCHA_NIVEL1}`);
const getManchaNivel2 = async () => await get<any>(`${PESQUISAR_MANCHA_NIVEL2}`);
const getDeposicaoObjetivoNivel1 = async () => await get<any>(`${PESQUISAR_DEPOSICAO_OBJETIVO_NIVEL1}`);
const getDeposicaoObjetivoNivel2 = async () => await get<any>(`${PESQUISAR_DEPOSICAO_OBJETIVO_NIVEL2}`);
const getTipologiaMob = async () => await get<any>(`${PESQUISAR_TIPOLOGIA_MOB}`);
const getMobMetodoDragagem = async () => await get<any>(`${PESQUISAR_METODO_DRAGAGEM}`);
const getMobMetodoDeposicao = async () => await get<any>(`${PESQUISAR_METODO_DEPOSICAO}`);
const getDeposicaoLocal1 = async () => await get<any>(`${PESQUISAR_DEPOSICAO_LOCAL_NIVEL1}`);
const getDeposicaoLocal2 = async () => await get<any>(`${PESQUISAR_DEPOSICAO_LOCAL_NIVEl2}`);
const getQualidadeSedimentos = async () => await get<any>(`${PESQUISAR_QUALIDADE_SEDIMENTOS}`);
const getGranulametriaSedimentos = async () => await get<any>(`${PESQUISAR_GRANULAMETRIA_SEDIMENTOS}`);
const getComponenteAcao = async () => await get<any>(`${PESQUISAR_COMPONENTE_ACAO}`);
const getPlaneamento1 = async () => await get<any>(`${PESQUISAR_PLANEAMENTO1}`);
const getPlaneamento2 = async () => await get<any>(`${PESQUISAR_PLANEAMENTO2}`);
const getPlaneamento3 = async () => await get<any>(`${PESQUISAR_PLANEAMENTO3}`);
const getEstadoIntervencao = async () => await get<any>(`${PESQUISAR_ESTADO_INTERVENCOES}`);
const getInstrumentoPlaneamento = async () => await get<any>(`${PESQUISAR_INSTRUMENTO_PLANEAMENTO}`);
const getInstrumentoFinanciamento = async () => await get<any>(`${PESQUISAR_INSTRUMENTO_FINANCIAMENTO}`);
const getAcaoEstado = async (data:any) => await get<any>(`${PESQUISAR_ACAO_ESTADO_POR_PERFIL}/` + data );
const getMoEstado = async () => await get<any>(`${PESQUISAR_MODELO_ESTADO}`);
const getMobilizacoEstado = async () => await get<any>(`${PESQUISAR_MOBILIZACOES_ESTADOS}`);
const getFuncao = async () => await get<any>(`${PESQUISAR_FUNCAO}`);
const getAcaoPlaneamento1 = async () => await get<any>(`${PESQUISAR_ACAO_PLANEAMENTO1}`);
const getAcaoPlaneamento2 = async () => await get<any>(`${PESQUISAR_ACAO_PLANEAMENTO2}`);
const getAcaoPlaneamento3 = async () => await get<any>(`${PESQUISAR_ACAO_PLANEAMENTO3}`);
const getAcaoPlaneamento4 = async () => await get<any>(`${PESQUISAR_ACAO_PLANEAMENTO4}`);
const getEstadoCandidatura = async () => await get<any>(`${PESQUISAR_ESTADO_CANDIDATURA}`);
const getMobilizacaoFuncoes = async () => await get<any>(`${PESQUISAR_MOBILIZACAO_FUNCOES}`);
const getMobilizacaoTipologia = async () => await get<any>(`${PESQUISAR_MOBILIZACAO_TIPOLOGIA}`);
const getMobilizacaoEstado = async (data:any) => await get<any>(`${PESQUISAR_MOBILIZACAO_ESTADO_POR_PERFIL}/` + data);
const getVzEstado = async () => await get<any>(`${VZ_ESTADO}`);
const getIntComponente = async () => await get<any>(`${GET_INT_COMPONENTE}`);
const getIntIndicador = async () => await get<any>(`${GET_INT_INDICADOR}`);
const getCodigoCandidatura = async () => await get<any>(`${GET_CODIGO_CANDIDATURA}`);
const getIntTipoMobilizacao = async () => await get<any>(`${GET_INT_TIPO_MOBILIZACAO}`);

const GetUsEstadoVuss = async () => await get<any>(`${GET_US_ESTADO_VUS}`);
const getTipoIncidencia = async () => await get<any>(`${GET_TIPO_INCIDENCIA}`);
const getDesignacaoIntervencao = async () => await get<any>(`${GET_DESIGNACAO_INTERVENCAO}`);
const getDesignacaoAcao = async () => await get<any>(`${GET_ALL_DESIGNACAO_ACAO}`);
const getCodigoIntervencao = async () => await get<any>(`${GET_CODIGO_INTERVENCAO}`);
const GetUsEstadoTitulo = async () => await get<any>(`${GET_US_ESTADO_TITULO}`);
const GetAgTema = async () => await get<any>(`${GET_AG_TEMA}`);
const getOcEstados = async () => await get<any>(GET_ESTADOS_OCORRENCIA);

const getTecnicos = async () => await get<any>(GET_TECNICOS);
const getEaEstado = async () => await get<any>(GET_EA_ESTADO);






const getEstado = async () => await get<any>(`${PESQUISAR_ESTADO}`);
const getMassaAgua = async () => await get<any>(`${PESQUISAR_MASSADAGUA}`);
const getCapitania = async () => await get<any>(`${PESQUISAR_CAPTANIA}`);
const getEntidades = async () => await get<any>(`${PESQUISAR_ENTIDADES}`);
const getTipoEntidades = async () => await get<any>(`${PESQUISAR_TIPOENTIDADE}`);
const getPalavrasChave = async () => await get<any>(`${PESQUISAR_PALAVRACHAVE}`);
const getIdiomas = async () => await get<any>(`${PESQUISAR_IDIOMA}`);
const getTipoAcesso = async (data:any) => await get<any>(`${GET_TIPO_ACESSO_POR_PERFIL}/` + data);

const getTipoRecurso = async () => await get<any>(`${PESQUISAR_TIPORECURSO}`);
const getCategoria = async () => await get<any>(`${PESQUISAR_CATEGORIA}`);
const getMoModeloSubTipos = async () => await get<any>(`${PESQUISAR_MO_MODELO_SUBTIPOS}`);
const getMoModeloTipos = async () => await get<any>(`${PESQUISAR_MO_MODELO_TIPOS}`);
const getAgEstados = async () => await get<any, any>(`${GET_AG_ESTADOS}`)
const getAgDecisoes = async () => await get<any, any>(`${GET_AG_DECISOES}`)
const getAgTipoPretensoes = async () => await get<any, any>(`${GET_AG_TIPO_PRETENSOES}`)
const getTiposProcesso = async () => await get<any>(`${PESQUISAR_TIPO_PROCESSO}`);
const getUsTiposProcesso = async () => await get<any>(`${PESQUISAR_US_TIPO_PROCESSO}`);
const getUsTiposUtilizacao = async () => await get<any>(`${GET_US_TIPO_UTILIZACAO}`)
const getLocalizacoesProcesso = async () => await get<any>(`${PESQUISAR_LOCALIZACAO_PROCESSO}`);
const getFasesProcedimentoDelimitacao = async () => await get<any>(`${PESQUISAR_FASE_PROCEDIMENTO_DE_ELIMINACAO}`);
const getValidacoesProva = async () => await get<any>(`${PESQUISAR_VALIDACAO_PROVA}`);
const getTiposParcela = async () => await get<any>(`${PESQUISAR_TIPO_PARCELA}`);
const getTiposSentenca = async () => await get<any>(`${PESQUISAR_TIPO_SENTENCA}`);
const getTiposDecisaoFinal = async () => await get<any>(`${PESQUISAR_TIPO_DECISAO_FINAL}`);
const getEstadosProcesso = async () => await get<any>(`${PESQUISAR_ESTADO_PROCESSO}`);
const getTiposPendencia = async () => await get<any>(`${PESQUISAR_TIPO_PENDENCIA}`);
const getTiposNotificacao = async () => await get<any>(`${PESQUISAR_TIPO_NOTIFICACAO}`);
const getTiposSituacaoNotificacao = async () => await get<any>(`${PESQUISAR_TIPO_SITUACAO_NOTIFICACAO}`);
const getCondicionantesProcessos = async () => await get<any>(`${PESQUISAR_CONDICIONANTES_PROCESSO}`);
const getTiposAcaoJudicial = async () => await get<any>(`${PESQUISAR_TIPO_JUDICIAL}`);
const getTiposDesafetacao = async () => await get<any>(`${PESQUISAR_TIPO_DESAFETACAO}`);
const getTiposAquisicao = async () => await get<any>(`${PESQUISAR_TIPO_AQUISICAO}`);
const getTiposIniciativa = async () => await get<any>(`${PESQUISAR_TIPO_INICIATIVA}`);
const getMoEstados = async () => await get<any>(`${GET_MO_ESTADOS}`);
const getTiposVus = async () => await get<any>(`${GET_US_TIPO_VUS}`);
const getEstadosVus = async () => await get<any>(`${GET_US_ESTADO_VUS}`);
const getEstadosTitulo = async () => await get<any>(`${GET_US_ESTADO_TITULO}`);
const getTiposComponenteVus = async () => await get<any>(`${GET_US_COMPONENTE_VUS}`);
const getFontesDadosVus = async () => await get<any>(`${GET_US_FONTE_DADOS_VUS}`);
const getVus = async () => await get<any>(`${GET_US_VUS}`);
const getFreguesiaFromCode = async(data: any) => await get<any, any>(GET_FREGUESIA_FROM_CODE + "/" + data);
const getDistritoFromCode = async(data: any) => await get<any, any>(GET_DISTRITO_FROM_CODE + "/" + data);
const getConcelhoFromCode = async(data: any) => await get<any, any>(GET_CONCELHO_FROM_CODE + "/" + data);
const getNuts3FromCode = async(data: any) => await get<any, any>(GET_NUTS_3_FROM_CODE + "/" + data);
const getUserById = async (data: any) => await get<any, any>(`${GET_USER_BY_ID}/` + data)
const getDhProcessosMarcacao = async () => await get<any,any>(GET_PROCESSOS_MARCACOES);
const getDhPareceres = async () => await get<any,any>(GET_PROCESSOS_PARECERES);
const getDhTipoDominio = async () => await get<any,any>(GET_DH_TIPO_DOMINIO);
const getDhRppAntes = async () => await get<any,any>(GET_DH_RECONHECIMENTO_PROPRIEDADE_PRIVADA);
const getDhRppDepois = async () => await get<any,any>(GET_DH_TIPO_ACAO_RECONHECIMENTOS);
const getDhRecurso = async () => await get<any,any>(PESQUISAR_TIPO_RECURSO);
const getDhDeferimento = async () => await get<any,any>(PESQUISAR_DEF_LICENCIAMENTO);
const getDhTipoLinha = async () => await get<any,any>(GET_TIPO_LINHA_DEMARCACAO);
const getProcContratacao = async () => await get<any,any>(GET_ASYNC_PROC_CONTRATACAO);
const GetSearchLimit = async () => await get<any,any>(GET_SEARCH_LIMIT);

export let freguesias: any[];
export let concelhos: any[];
export let distritos: any[];
export let arhs: any[];
export let praias: any[];
export let tecnico: any[];
export let nuts1: any[];
export let lugarToponimico: any[];
export let designacaoLinha: any[];
export let regiaoHidrografica: any[];
export let nuts2: any[];
export let nuts3: any[];

//INTERVENCOES
export let mancha1: any[];
export let mancha2: any[];
export let deposicaoObjetivo1: any[];
export let deposicaoObjetivo2: any[];
export let deposicaoLocal1: any[];
export let deposicaoLocal2: any[];
export let tip1: any[];
export let tip2: any[];
export let tip3: any[];
export let prioridade: any[];
export let prioridadePalXXI: any[];
export let tipEngenharia: any[];
export let tipologiaMob: any[];
export let metotodoDragagem: any[];
export let metodoDeposicao: any[];
export let qualidadeSedimentos: any[];
export let granulametriaSedimentos: any[];
export let componenteAcao: any[];
export let naturezaAcao: any[];
export let designacaoIntervencao: any[];
export let designacaoAcao: any[];
export let codigoIntervencao: any[];
export let tipoEngenharia: any[];
export let tipoPlaneamento: any[];
export let planeamento1: any[];
export let planeamento2: any[];
export let planeamento3: any[];
export let estadoIntervencao: any[];
export let instrumentoPlaneamento: any[];
export let acaoEstado: any[];
export let eaEstado: any[];
export let instrumentoFinanciamento: any[];
export let mobilizacaoEstado: any[];
export let mobilizacaoFuncoes: any[];
export let acaoPlaneamento1: any[];
export let acaoPlaneamento2: any[];
export let acaoPlaneamento3: any[];
export let acaoPlaneamento4: any[];
export let estadoCandidatura: any[];
export let isTabSelection : boolean;
export let entidadeUser: string;
export let objectEntidadeUser: any;
export let intComponente: any[];
export let intIndicador: any[];
export let codigoCandidatura: any[];
export let _export: any;
export let _exportPdf: any;
export let searchLimit: any;

export let estados: any[];
export let massaagua: any[];
export let capitania: any[];
export let diplomas: any[];
//export let capitanias: any[];
export let entidades: any[];
export let fotoObliqua: any[];
export let palavraschave: any[];
export let idioma: any[];
export let tipoacesso: any[];
export let tiporecurso: any[];
export let categorias: any[];
export let modelosTipos: any[];
export let tiposMobilizacao : any[];
export let modelosSubtipos: any[];
export let coordenadasSelected: any;
export let coordenadasPoligono: any;
export let coordenadasLinhaSelected: any;
export let geoPortalUrl: string;
export let menuItemSelected: string;
export let geoPortalUser: any;
export let agTipoPretensoes: any[];
export let agEstados: any[];
export let agDecisoes: any[];
export let status: any[];
export let tipossProcesso: any[];
export let tipoDeProcesso: any[];
export let TiposUtilizacao: any[];
export let localizacoesProcesso: any[];
export let fasesProcedimentoDelimitacao: any[];
export let validacoesProva: any[];
export let tiposParcela: any[];
export let tiposSentenca: any[];
export let tiposDecisaoFinal: any[];
export let estadosProcesso: any[];
export let tiposPendencia: any[];
export let tiposNotificacao: any[];
export let tiposSituacaoNotificacao: any[];
export let condicionantesProcessos: any[];
export let tiposAcaoJudicial: any[];
export let tiposDesafetacao: any[];
export let tiposAquisicao: any[];
export let tiposIniciativa: any[];
export let tiposVus: any[];
export let estadosVus: any[];
export let tipoIncidencia: any[];
export let estadosTitulo: any[];
export let tiposComponenteVus: any[];
export let fontesDadosVus: any[];
export let vus: any[];
export let fotoIndex = 0;
export let statusLocal: any[];
export let tipoEntidades: any[];
export let agTema: any[];
export let ocEstados: any[];
export let tipoTitulos: any[];
export let dhProcessosMarcacoes: any[];
export let dhPareceres: any[];
export let dhTipoDominio: any[];
export let dhRppAntes: any[];
export let dhRppDepois: any[];
export let dhRecurso: any[];
export let dhDeferimento: any[];
export let dhTipoLinha: any[];
export let procContratacao: any[];
export let moEstados: any[];

export let vzEstados: any[];
export let tecnicos: any[];

export const setExcelExport = (value : any) => {
  _export = value;
}

export const setPdfExport = (value : any) => {
  _exportPdf = value
}

const getCombos = async () => {
  const [nuts1, 
    nuts2, 
    nuts3, 
    distritos, 
    freguesias, 
    concelhos, 
    arhs, 
    praias,
  entidades,
tecnicos,
massasAgua] = await Promise.all([
    getNuts1(),
    getNuts2(),
    getNuts3(),
    getDistritos(),
    getFreguesias(),
    getConcelhos(),
    getArhs(),
    getPraias(),
    getEntidades(),
    getTecnicos(),
    getMassaAgua()
  ]);
  console.log(nuts1);
  console.log(nuts2);
  console.log(nuts3);
  return { nuts1, 
    nuts2, 
    nuts3, 
    distritos, 
    freguesias, 
    concelhos, 
    arhs, 
    praias, 
    entidades,
    tecnicos,
  massasAgua };
}

const timeout = 600000;

const decode = (str: string): string => atob(str);
const encode = (str: string): string => btoa(str);

export const setTabSelection = (value: boolean) => {
  isTabSelection = value;
}

async function createRequest<RequestDataType, ResponseType>(
  method: Method,
  endpoint: string,
  data?: RequestDataType,
  contentType = 'application/json'
) {
  const dataUser = localStorage.getItem(AUTH_LOCALSTORAGE)
  const token = JSON.parse(dataUser as string)?.token ?? ''

  const api = axios.create({
    baseURL: API_URL,
    headers: {
      accept: 'application/json',
      'Content-Type': contentType,
      Authorization: token ? `Bearer ${token}` : false,
    },
    timeout: timeout,
  })

  try {
    const response = await api.request<
      RequestDataType,
      AxiosResponse<ResponseType>
    >({ method, url: endpoint, data: data ? data : {} })

    return response.data
  } catch (error) {
    const axiosAbort = error as AxiosError
    if (axiosAbort.response?.status == 401) {
      clearSession();
      const iframe: any = document.getElementById('iframeGeoPortal')
      if (iframe) {
        iframe.src = BASE_GEOPORTAL_URL + "Account/Logout"
      } else {
        if (window.location.hash.indexOf("/login") != -1) {
          throw error;
        }
      }
    } else if (axiosAbort.response?.status == PERMISSION_ERROR_STATUS_CODE ||
      axiosAbort.response?.status == NOT_AUTHORIZED_ERROR_STATUS_CODE) {
      postMessage({type: "errorMsg", value: {message: "Não tem permissões para essa funcionalidade"}}, "*");
      console.log(axiosAbort.message)
      throw error;
    }
    else {
      console.log(axiosAbort.message)
      throw error;
    }
  }
}

export const clearSession = () => {
  sessionStorage.clear();
  localStorage.clear();
  sessionStorage.clear();
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}

interface Column {
  field: string;
  title: string;
  width: number | string;
  show: boolean;
}

  export const exportPDFWithMethod = (columns: any[], dataToExport: any[], itemsPerPage = 8) => {
    const gridElement = document.querySelector(".k-height-container") as any;
    const modulo = sessionStorage.getItem("Modulo");

    const generatePDF = async (pageNum: number, templateHTML: string) => {
        const startIndex = pageNum * itemsPerPage;
        const endIndex = Math.min(startIndex + itemsPerPage, dataToExport.length);
        const currentPageData = dataToExport.slice(startIndex, endIndex);

        let dynamicColumnHeaders = '';
        let tableRows = '';
        columns.forEach(column => {
          dynamicColumnHeaders += `<td style="width: 120px;border: 1px solid #1ba49c;">${column.title}</td>`;
      });
      

        currentPageData.forEach(item => {
            let row = '';
            columns.forEach(column => {
                const cellValue = item[column.field] !== undefined && item[column.field] !== null ? item[column.field] : '';
                if (itemsPerPage < 8) {
                  row += `<td style="border: 1px solid #1ba49c;height: 100px; font-size: 12px;margin:0px;">${cellValue}</td>`;
                } 
                else if (itemsPerPage == 8) {
                  row += `<td style="border: 1px solid #1ba49c;height:50px">${cellValue}</td>`;
                }
                else {
                  row += `<td style="border: 1px solid #1ba49c;">${cellValue}</td>`;
                }
                
            });
            tableRows += `<tr>${row}</tr>`;
        });

        const currentDate = new Date().toLocaleDateString();

        const filledTemplate = templateHTML
            .replace('{{columnHeaders}}', dynamicColumnHeaders)
            .replace('{{modulo}}', sessionStorage.getItem("Modulo")?.toUpperCase() ?? '')
            .replace('{{tableRows}}', tableRows)
            .replace('{{currentDate}}', currentDate)
            .replace('{{base64SiarlImage}}', base64SiarlImage)
            .split('{{base64ApaImage}}').join(base64ApaImage)
            .replace('{{base64FooterImages}}', base64FooterImages)
            .replace('{{pageNum}}', (pageNum + 1).toString())
            .replace('{{totalPages}}', Math.ceil(dataToExport.length / itemsPerPage).toString());

        const pdfData = await drawDOM(gridElement, {  
            paperSize: "A4",
            landscape: true,
            scale: scalePDF,
            margin: {
              left: "1cm"
            },
            template: () => filledTemplate
          });


        return pdfData;
    };

    return fetch('templates/listagemTemplate.html')
        .then(response => {
            if (!response.ok) {
                throw new Error('Erro ao ler template');
            }
            return response.text();
        })
        .then(async templateHTML => {
            const totalPages = Math.ceil(dataToExport.length / itemsPerPage);
            let finalPDFData: Group = new Group(); 

            for (let pageNum = 0; pageNum < totalPages; pageNum++) {
                const pdfData = await generatePDF(pageNum, templateHTML);
                if (pageNum == 0) {
                  finalPDFData = pdfData;
                } else {
                  finalPDFData.children.push(pdfData.children[0]);
                }
            }

              defineFont({
                  'DejaVu Sans': URL_FONT_GRID_PDF
              });

            return exportPDF(finalPDFData);
        })
        .catch(error => {
            console.error('Error loading template.html:', error);
        });
};

export const selectCriterioGeograficoNenhum = () => {
  setCoordenadasPoligono(undefined)
  const iframe: any = document.getElementById('iframeGeoPortal')
  iframe.contentWindow?.postMessage({ type: "SiarlRemoveSelection", value: "true" }, '*')
  iframe.contentWindow?.postMessage({ type: "SiarlDeselectMapArea", value: "true" }, '*')
}

export const b64toBlob = (b64Data: string, contentType ='', sliceSize=512) => {
    
  const binaryString = atob(b64Data);

  // Create an array to store binary data
  const byteArray = new Uint8Array(binaryString.length);

  // Fill the array with character codes after encoding them in ISO-8859-1
  for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = binaryString.charCodeAt(i);
  }

    const blob = new Blob([byteArray], {type: contentType});
    return blob;
}

export const handleDownload = (fileContent: any, fileName: any) => {
  const link = document.createElement('a')
  link.href = 'data:application/zip;base64,' + fileContent
  link.download = fileName
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
};

export const postFormData = async <RequestDataType, ResponseType>(
  endpoint: string,
  data: RequestDataType
) => await createRequest<RequestDataType, ResponseType>('post', endpoint, data, "multipart/form-data")

export const get = async <ResponseType, RequestDataType = never>(
  endpoint: string,
) => await createRequest<RequestDataType, ResponseType>('get', endpoint)

export const getWithBody = async <RequestDataType, ResponseType>(
  endpoint: string,
  data: RequestDataType
) => await createRequest<RequestDataType, ResponseType>('get', endpoint, data)

export const post = async <RequestDataType, ResponseType>(
  endpoint: string,
  data: RequestDataType
) => await createRequest<RequestDataType, ResponseType>('post', endpoint, data)

export const put = async <RequestDataType, ResponseType>(
  endpoint: string,
  data: RequestDataType
) => await createRequest<RequestDataType, ResponseType>('put', endpoint, data)

export const patch = async <RequestDataType, ResponseType>(
  endpoint: string,
  data: RequestDataType
) => await createRequest<RequestDataType, ResponseType>('patch', endpoint, data)

export const del = async <RequestDataType, ResponseType>(
  endpoint: string,
  data: RequestDataType
) =>
  await createRequest<RequestDataType, ResponseType>('delete', endpoint, data)


export const fillEstadoIntervencaoAsync = () => {
  if (SessionStorageService.getItem("estadoIntervencao")) {
    estadoIntervencao = SessionStorageService.getItem("estadoIntervencao");
  } else {
    getEstadoIntervencao().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("estadoIntervencao", result);
      estadoIntervencao = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTipoTituloAsync = (tipoTitulo: any = undefined) => {
  if (tipoTitulo) {
    SessionStorageService.setItem("tipoTitulos", tipoTitulo);
    tipoTitulos = tipoTitulo;
    return
  }
  if (SessionStorageService.getItem("tipoTitulos")) {
    tipoTitulos = SessionStorageService.getItem("tipoTitulos");
  } else {
    getAllTipoTitulos().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tipoTitulos", result);
      tipoTitulos = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const stringToDate = (dateString: string): Date => {
  const [day, month, year] = dateString.split('/').map(Number);
  return new Date(year, month - 1, day);
}

export const fillDistritosAsync = (distrito: any = undefined) => {
  if (distrito) {
    SessionStorageService.setItem("distritos", distrito);
    distritos = distrito;
    return
  }
  if (SessionStorageService.getItem("distritos")) {
    distritos = SessionStorageService.getItem("distritos");
  } else {
    getDistritos().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("distritos", result);
      distritos = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillConcelhosAsync = (concelho: any = undefined) => {
  if (concelho) {
    SessionStorageService.setItem("concelhos", concelho);
      concelhos = concelho;
      return;
  }
  if (SessionStorageService.getItem("concelhos")) {
    concelhos = SessionStorageService.getItem("concelhos");
  } else {
    getConcelhos().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("concelhos", result);
      concelhos = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const refreshOcorrencesSearch = () => {
  if (SessionStorageService.getItem('resultadoOcorrenciasPesquisa')) {
    const results = JSON.parse(
      SessionStorageService.getItem('resultadoOcorrenciasPesquisa') ?? ''
    )

    if (results) {
      const iframe: any = document.getElementById('iframeGeoPortal')
      const ids: number[] = []
      const idsApoio: number[] = []
      results.forEach((element: any) => {
        ids.push(element.id)
      })
      iframe.contentWindow?.postMessage(
        { type: 'SiarlOcorrenciasSearchNoCenter', value: ids },
        '*'
      )
    }
  }
}

export const refreshEntidadesSearch = () => {
  if (SessionStorageService.getItem('resultadoEntidadePesquisa')) {
    const results = JSON.parse(
      SessionStorageService.getItem('resultadoEntidadePesquisa') ?? ''
    )
    if (results) {
      const iframe: any = document.getElementById('iframeGeoPortal')
      const ids: number[] = []
      const idsApoio: number[] = []
      results.forEach((element: any) => {
        ids.push(element.id)
      })
      iframe.contentWindow?.postMessage(
        { type: 'SiarlEntidadesSearch', value: ids, nocenter: true },
        '*'
      )
    }
  }
}

export const mobilecheck = () => {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];
    
    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
};
export const refreshPesquisaSearch = (resultadoItem: string, nomeEvento: string, center = false) => {

  if (SessionStorageService.getItem(resultadoItem)) {
    let results = [];
    try {
      results = JSON.parse(SessionStorageService.getItem(resultadoItem));
    } catch {
      return;  
    }

    if (results) {
      const iframe: any = document.getElementById('iframeGeoPortal');
      if (iframe?.contentWindow) {
        const ids: number[] = results.map((element: any) => element.id);
        iframe.contentWindow.postMessage(
          { type: nomeEvento, value: ids, nocenter: !center },
          '*'
        );
      }
    }
  }
};
export const fillFreguesiasAsync = (freguesia: any = undefined) => {
  if (freguesia) {
    SessionStorageService.setItem("freguesias",freguesia);
    freguesias = freguesia;
    return;
  }
  if (SessionStorageService.getItem("freguesias")) {
    freguesias = SessionStorageService.getItem("freguesias");
  } else {
    getFreguesias().then((result: any[]) => {
      if (!result) { return; }
      SessionStorageService.setItem("freguesias",result);
      freguesias = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTipoEntidades = () => {
  if (SessionStorageService.getItem("tipoEntidades")) {
    tipoEntidades = SessionStorageService.getItem("tipoEntidades")
  } else {
    getTipoEntidades().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tipoEntidades", result);
      tipoEntidades = result;
    }).catch(error => {
      handleError(error);
    })
  }
};

const fillAgDecisoes = () => {
  if (SessionStorageService.getItem("agDecisoes")){
    agDecisoes = SessionStorageService.getItem("agDecisoes");
  } else {
    getAgDecisoes().then(result => {
      SessionStorageService.setItem("agDecisoes", result);
      agDecisoes = result;
    });
  }
}

export const fillArhsAsync = (arh: any = undefined) => {
  if (arh) {
    SessionStorageService.setItem("arhs", arh);
    arhs = arh;
    return;
  }
  if (SessionStorageService.getItem("arhs")) {
    arhs = SessionStorageService.getItem("arhs");
  } else {
    getArhs().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("arhs", result);
      arhs = result;
    }).catch(error => {
      handleError(error);
    })
  }
}



export const fillPraiasAsync = (praia: any = undefined) => {
  if (praia) {
    SessionStorageService.setItem("praias", praia);
    praias = praia;
    return;
  }
  if (SessionStorageService.getItem("praias")) {
    praias = SessionStorageService.getItem("praias");
  } else {
    getPraias().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("praias", result);
      praias = result;
    }).catch(error => {
      handleError(error);
    })
  }
}



export const fillEstadoAsync = () => {
  if (SessionStorageService.getItem("estados")) {
    estados = SessionStorageService.getItem("estados");
  } else {
    getEstado().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("estados", result);
      estados = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillMassaAguaAsync = (massaaguaResult: any = undefined) => {
  if (massaagua) {
    SessionStorageService.setItem("massaagua", massaaguaResult);
      massaagua = massaaguaResult;
      return;
  }
  if (SessionStorageService.getItem("massaagua")) {
    massaagua = SessionStorageService.getItem("massaagua");
  } else {
    getMassaAgua().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("massaagua", result);
      massaagua = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillCapitaniaAsync = () => {
  if (SessionStorageService.getItem("capitanias")) {
    capitania = SessionStorageService.getItem("capitanias");
  } else {
    getCapitania().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("capitanias", result);
      capitania = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const getMenuItems = () => {
  return SessionStorageService.getItem("menuItems");
}

export const setMenuItems = (value: any) => {
  SessionStorageService.setItem("menuItems", value);
}

export const userLogged = () => {

  const loggedUser = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) || '{}');
  tecnico = loggedUser?.user?.username

}


export const userLoggedObject = () => {

  const loggedUser = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) || '{}');
  return loggedUser
}

export const exportToCSV =(
  data: any[],
  fileName: string,
  delimiter = ";"
) => {
  if (!data || data.length === 0) {
      console.warn("A lista de dados está vazia.");
      return;
  }

  // Extrai os cabeçalhos das chaves do primeiro objeto
  const headers = Object.keys(data[0]);

  const csvRows = data.map(row => 
      headers.map(field => {
          let value = (row as any)[field];

          if (value === null || value === undefined) value = "";

          // Coloca aspas em todos os valores
          value = `"${String(value).replace(/"/g, '""')}"`; // Escapa aspas duplas dentro do valor

          return value;
      }).join(delimiter)
  );

  // Junta cabeçalhos e dados
  const csvContent = [headers.join(delimiter), ...csvRows].join("\n");

  // Adiciona BOM para garantir caracteres especiais no Excel
  const csvBlob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(csvBlob);
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const exportToExcelWithTabsIntervencao = (
  list1: any[], list1Name: string,
  list2: any[], list2Name: string,
  fileName: string,
  list3: any[] = [], list3Name = '',
  list4: any[] = [], list4Name = '',
  list5: any[] = [], list5Name = '',
  list6: any[] = [], list6Name = '',
  list7: any[] = [], list7Name = '',
  list8: any[] = [], list8Name = '',
  list9: any[] = [], list9Name = ''
) => {
  const wb = XLSX.utils.book_new();

  const ws1 = XLSX.utils.json_to_sheet(list1);
  XLSX.utils.book_append_sheet(wb, ws1, list1Name);

  const ws2 = XLSX.utils.json_to_sheet(list2);
  XLSX.utils.book_append_sheet(wb, ws2, list2Name);

  if (list3.length > 0) {
    const ws3 = XLSX.utils.json_to_sheet(list3);
    XLSX.utils.book_append_sheet(wb, ws3, list3Name);
  }

  if (list4.length > 0) {
    const ws4 = XLSX.utils.json_to_sheet(list4);
    XLSX.utils.book_append_sheet(wb, ws4, list4Name);
  }

  if (list5.length > 0) {
    const ws5 = XLSX.utils.json_to_sheet(list5);
    XLSX.utils.book_append_sheet(wb, ws5, list5Name);
  }

  if (list6.length > 0) {
    const ws6 = XLSX.utils.json_to_sheet(list6);
    XLSX.utils.book_append_sheet(wb, ws6, list6Name);
  }

  if (list7.length > 0) {
    const ws7 = XLSX.utils.json_to_sheet(list7);
    XLSX.utils.book_append_sheet(wb, ws7, list7Name);
  }

  if (list8.length > 0) {
    const ws8 = XLSX.utils.json_to_sheet(list8);
    XLSX.utils.book_append_sheet(wb, ws8, list8Name);
  }

  if (list9.length > 0) {
    const ws9 = XLSX.utils.json_to_sheet(list9);
    XLSX.utils.book_append_sheet(wb, ws9, list9Name);
  }

  XLSX.writeFile(wb, `${fileName}.xlsx`);
};

export const GetUserNameTecnico = async (utilizador_id: number | undefined) => {
  let tecnico = "";
   const userLocal = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? "{}");
    if (utilizador_id) {
      const user = await getUserById(utilizador_id);
      tecnico = user?.userName;
      if (!tecnico) {
        tecnico = userLocal?.user?.username ?? undefined
      }
    } else {
      tecnico = userLocal?.user?.username ?? undefined
    }
    return tecnico;
}

export const isUserLogged = () => {
  const loggedUser = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) || '{}');
  return !!loggedUser?.user
}

export const preventPropsNullValues = (collection: any[], property: string) => {
  if (!collection) return []
  return collection?.map((e: any) => ({ ...e, [property]: `${!e?.[property] || e?.[property].length === 0 ? "N/D" : e?.[property]}` }))
}

export const fillEntidadeByUserAsync = () => {

  const entidade_id = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? '')
  ?.user?.entidadeId

  getEntidadeUser(entidade_id).then((result) => {
    if (!result) { return; }
    console.log(result)
    entidadeUser = result?.nome;
    objectEntidadeUser = result
    
  }).catch(error => {
    handleError(error);
  })
}

export const fillEntidadesAsync = (entidade: any = undefined) => {
  if (entidade) {
    entidades = entidade;
    entidades = preventPropsNullValues(entidades, "nome")
    return;
  }
  // postMessage({type: "showLoader"}, "*")
  getEntidades().then((result) => {
    if (!result) { return; }
    entidades = result;
    entidades = preventPropsNullValues(entidades, "nome")
    console.log(entidades);
    // postMessage({type: "hideLoader"}, "*")
});
}

export const fillEntidadesAsyncWithoutLoader = () => {
  getEntidades().then((result) => {
    if (!result) { return; }
    entidades = result;
    entidades = preventPropsNullValues(entidades, "nome")
    console.log(entidades);
});
}

export const fillPalavrasChaveAsync = () => {
  if (SessionStorageService.getItem("palavraschave")) {
    palavraschave = SessionStorageService.getItem("palavraschave");
  } else {
    getPalavrasChave().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("palavraschave", result);
      palavraschave = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const geomPolygonIsValid = async(flatCoordinates: any) => {
  if (flatCoordinates) {
    const geomIsValid = await post<any, any>(`${IS_GEOM_POLYGON_VALID}`, flatCoordinates);

    if (!geomIsValid) {
      postMessage({type:"infoMsg", value: {message: "Geometria inválida"}})
      return false
    }
  }
  return true
}

export const geomLineIsValid = async(flatCoordinatesLine: any) => {
  if (flatCoordinatesLine) {
    const geomIsValid = await post<any, any>(`${IS_GEOM_LINE_VALID}`, flatCoordinatesLine);

    if (!geomIsValid) {
      postMessage({type:"infoMsg", value: {message: "Geometria inválida"}})
      return false;
    }
  }
  return true;
}

export const fillIdiomasAsync = () => {
  if (SessionStorageService.getItem("idiomas")) {
    idioma = SessionStorageService.getItem("idiomas");
  } else {
    getIdiomas().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("idiomas", result);
      idioma = result;
    }).catch(error => {
      handleError(error);
    })
  }
}



export const fillTipoAcessoAsync = () => {
  const userObj = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? '');

  if (SessionStorageService.getItem("tipoacesso")) {
    tipoacesso = SessionStorageService.getItem("tipoacesso");
  } else {
    getTipoAcesso(userObj?.user?.id).then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tipoacesso", result);
      tipoacesso = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTipoRecursoAsync = () => {
  if (SessionStorageService.getItem("tiporecurso")) {
    tiporecurso = SessionStorageService.getItem("tiporecurso");
  } else {
    getTipoRecurso().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tiporecurso", result);
      tiporecurso = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillCategoriaAsync = () => {
  if (SessionStorageService.getItem("categorias")) {
    categorias = SessionStorageService.getItem("categorias");
  } else {
    getCategoria().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("categorias", result);
      categorias = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillNuts1Async = (n1 :any = undefined) => {
  if (n1) {
    SessionStorageService.setItem("nuts1", n1);
    nuts1 = n1;
    return;
  }
  if (SessionStorageService.getItem("nuts1")) {
    nuts1 = SessionStorageService.getItem("nuts1");
  } else {
    getNuts1().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("nuts1", result);
      nuts1 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillNuts2Async = (n2: any = undefined) => {
  if (n2) {
    SessionStorageService.setItem("nuts1", n2);
    nuts2 = n2;
    return;
  }
  if (SessionStorageService.getItem("nuts1")) {
    nuts2 = SessionStorageService.getItem("nuts1");
  } else {
    getNuts2().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("nuts1", result);
      nuts2 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}


export const fillUsTiposProcessoAsync = () => {
  if (SessionStorageService.getItem("tipoDeProcesso")) {
    tipoDeProcesso = SessionStorageService.getItem("tipoDeProcesso");
  } else {
    getUsTiposProcesso().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tipoDeProcesso", result);
      tipoDeProcesso = result;
      console.log("result")
      console.log(result)
    }).catch(error => {
      handleError(error);
    })
  }
} 

export const fillUsTiposUtilizacaoAsync = () => {
  if (SessionStorageService.getItem("tipoDeUtilizacao")) {
    TiposUtilizacao = SessionStorageService.getItem("tipoDeUtilizacao");
  } else {
    getUsTiposUtilizacao().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tipoDeUtilizacao", result);
      TiposUtilizacao = result;
    }).catch(error => {
      handleError(error);
    })
  }
}  




export const fillTiposProcessoAsync = () => {
  if (SessionStorageService.getItem("tiposProcesso")) {
    tipossProcesso = SessionStorageService.getItem("tiposProcesso");
  } else {
    getTiposProcesso().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tiposProcesso", result);
      tipossProcesso = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillLocalizacoesProcessosAsync = () => {
  if (SessionStorageService.getItem("localizacoesProcesso")) {
    localizacoesProcesso = SessionStorageService.getItem("localizacoesProcesso");
  } else {
    getLocalizacoesProcesso().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("localizacoesProcesso", result);
      localizacoesProcesso = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillEstadosProcessoAsync = () => {
  if (SessionStorageService.getItem("estadosProcesso")) {
    estadosProcesso = SessionStorageService.getItem("estadosProcesso");
  } else {
    getEstadosProcesso().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("estadosProcesso", result);
      estadosProcesso = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillEstadosOcorrenciaAsync = () => {
  if (SessionStorageService.getItem("estadosOcorrencia")) {
    ocEstados = SessionStorageService.getItem("estadosOcorrencia");
  } else {
    getOcEstados().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("estadosOcorrencia", result);
      ocEstados = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTecnicosAsync = (tecnico: any = undefined) => {
  if (tecnico) {
    SessionStorageService.setItem("tecnicos", tecnico);
    tecnicos = tecnico;
    return;
  }
  if (SessionStorageService.getItem("tecnicos")) {
    tecnicos = SessionStorageService.getItem("tecnicos");
  } else {
    getTecnicos().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tecnicos", result);
      tecnicos = result;
    }).catch(error => {
      handleError(error);
    })
  }
}


export const fillTiposNotificacaoAsync = () => {
  if (SessionStorageService.getItem("tiposNotificacao")) {
    tiposNotificacao = SessionStorageService.getItem("tiposNotificacao");
  } else {
    getTiposNotificacao().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tiposNotificacao", result);
      tiposNotificacao = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTiposSituacaoNotificacaoAsync = () => {
  if (SessionStorageService.getItem("tiposSituacaoNotificacao")) {
    tiposSituacaoNotificacao = SessionStorageService.getItem("tiposSituacaoNotificacao");
  } else {
    getTiposSituacaoNotificacao().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tiposSituacaoNotificacao", result);
      tiposSituacaoNotificacao = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillFasesProcedimentoDelimitacaoAsync = () => {
  if (SessionStorageService.getItem("fasesProcedimentoDelimitacao")) {
    fasesProcedimentoDelimitacao = SessionStorageService.getItem("fasesProcedimentoDelimitacao");
  } else {
    getFasesProcedimentoDelimitacao().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("fasesProcedimentoDelimitacao", result);
      fasesProcedimentoDelimitacao = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTiposSentencaAsync = () => {
  if (SessionStorageService.getItem("tiposSentenca")) {
    tiposSentenca = SessionStorageService.getItem("tiposSentenca");
  } else {
    getTiposSentenca().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tiposSentenca", result);
      tiposSentenca = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillDhProcessosMarcacoesAsync = () => {
  if (SessionStorageService.getItem("dhProcessosMarcacoes")) {
    dhProcessosMarcacoes = SessionStorageService.getItem("dhProcessosMarcacoes");
  } else {
    getDhProcessosMarcacao().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("dhProcessosMarcacoes", result);
      dhProcessosMarcacoes = result;
    }).catch(error => {
      handleError(error);
    });
  }
}

export const fillDhPareceres = () => {
  if (SessionStorageService.getItem("dhPareceres")) {
    dhPareceres = SessionStorageService.getItem("dhPareceres");
  } else {
    getDhPareceres().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("dhPareceres", result);
      dhProcessosMarcacoes = result;
    }).catch(error => {
      handleError(error);
    });
  }
}

export const fillDhTipoDominioAsync = () => {
  if (SessionStorageService.getItem("dhTipoDominio")) {
    dhTipoDominio = SessionStorageService.getItem("dhTipoDominio");
  } else {
    getDhTipoDominio().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("dhTipoDominio", result);
      dhTipoDominio = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillDhRppAntesAsync = () => {
  if (SessionStorageService.getItem("dhRppAntes")) {
    dhRppAntes = SessionStorageService.getItem("dhRppAntes");
  } else {
    getDhRppAntes().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("dhRppAntes", result);
      dhRppAntes = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillDhRppDepoisAsync = () => {
  if (SessionStorageService.getItem("dhRppDepois")) {
    dhRppDepois = SessionStorageService.getItem("dhRppDepois");
  } else {
    getDhRppDepois().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("dhRppDepois", result);
      dhRppDepois = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillDhRecursoAsync = () => {
  if (SessionStorageService.getItem("dhRecurso")) {
    dhRecurso = SessionStorageService.getItem("dhRecurso");
  } else {
    getDhRecurso().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("dhRecurso", result);
      dhRecurso = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillDhDeferimentoAsync = () => {
  if (SessionStorageService.getItem("dhDeferimento")) {
    dhDeferimento = SessionStorageService.getItem("dhDeferimento");
  } else {
    getDhDeferimento().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("dhDeferimento", result);
      dhDeferimento = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillDhTipoLinhaAsync = () => {
  if (SessionStorageService.getItem("dhTipoLinha")) {
    dhTipoLinha = SessionStorageService.getItem("dhTipoLinha");
  } else {
    getDhTipoLinha().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("dhTipoLinha", result);
      dhTipoLinha = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTiposDecisaoFinalAsync = () => {
  if (SessionStorageService.getItem("decisaoFinal")) {
    tiposDecisaoFinal = SessionStorageService.getItem("decisaoFinal");
  } else {
    getTiposDecisaoFinal().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("decisaoFinal", result);
      tiposDecisaoFinal = result;
    }).catch(error => {
      handleError(error);
    })
  }
}


export const fillValidacoesProvaAsync = () => {
  if (SessionStorageService.getItem("validacoesProva")) {
    validacoesProva = SessionStorageService.getItem("validacoesProva");
  } else {
    getValidacoesProva().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("validacoesProva", result);
      validacoesProva = result;
    }).catch(error => {
      handleError(error);
    })
  }
}


export const fillTiposParcelaProvaAsync = () => {
  if (SessionStorageService.getItem("tiposParcela")) {
    tiposParcela = SessionStorageService.getItem("tiposParcela");
  } else {
    getTiposParcela().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tiposParcela", result);
      tiposParcela = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTiposPendenciaAsync = () => {
  if (SessionStorageService.getItem("tiposPendencia")) {
    tiposPendencia = SessionStorageService.getItem("tiposPendencia");
  } else {
    getTiposPendencia().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tiposPendencia", result);
      tiposPendencia = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillCondicionantesProcessosAsync = () => {
  if (SessionStorageService.getItem("condicionanteProcessos")) {
    condicionantesProcessos = SessionStorageService.getItem("condicionanteProcessos");
  } else {
    getCondicionantesProcessos().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("condicionanteProcessos", result);
      condicionantesProcessos = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTiposAcaoJudicialAsync = () => {
  if (SessionStorageService.getItem("tiposAcaoJudicial")) {
    tiposAcaoJudicial = SessionStorageService.getItem("tiposAcaoJudicial");
  } else {
    getTiposAcaoJudicial().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tiposAcaoJudicial", result);
      tiposAcaoJudicial = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTiposDesafetacaoAsync = () => {
  if (SessionStorageService.getItem("tiposDesafetacao")) {
    tiposDesafetacao = SessionStorageService.getItem("tiposDesafetacao");
  } else {
    getTiposDesafetacao().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tiposDesafetacao", result);
      tiposDesafetacao = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTiposAquisicaoAsync = () => {
  if (SessionStorageService.getItem("tiposAquisicao")) {
    tiposAquisicao = SessionStorageService.getItem("tiposAquisicao");
  } else {
    getTiposAquisicao().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tiposAquisicao", result);
      tiposAquisicao = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTiposIniciativaAsync = () => {
  if (SessionStorageService.getItem("tiposIniciativa")) {
    tiposIniciativa = SessionStorageService.getItem("tiposIniciativa");
  } else {
    getTiposIniciativa().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("tiposIniciativa", result);
      tiposIniciativa = result;
    }).catch(error => {
      handleError(error);
    })
  }
}


export const fillNuts3Async = (n3: any = undefined) => {
  if (n3) {
    SessionStorageService.setItem("nuts3", n3);
    nuts3 = n3;
    return;
  }
  if (SessionStorageService.getItem("nuts3")) {
    nuts3 = SessionStorageService.getItem("nuts3");
  } else {
    getNuts3().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("nuts3", result);
      nuts3 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillModelosTiposAsync = () => {

  const modelosTiposStored = SessionStorageService.getItem("modelosTipos") ?? undefined;
  if (modelosTiposStored) {
    modelosTipos = modelosTiposStored;
  } else {
    getMoModeloTipos().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("modelosTipos", result);
      modelosTipos = result;
    }).catch((error) => {
      handleError(error);
    })
  }
}

export const fillIntTipoMobilizacaoAsync = () => {
  const tiposMobilizacaoStored = SessionStorageService.getItem("intTipoMobilizacao") ?? undefined;
  if (tiposMobilizacaoStored) {
    tiposMobilizacao = tiposMobilizacaoStored;
  } else {
    getIntTipoMobilizacao().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("intTipoMobilizacao", result);
      tiposMobilizacao = result;
    }).catch((error) => {
      handleError(error);
    })
  }
}

type Status = {
  designacao: string;
  valor: boolean;
};

export const useCombos = () => {

  const [arhs, setArhs] = useState([] as any[]);
  const [concelhos, setConcelhos] = useState([] as any[]);
  const [distritos, setDistritos] = useState([] as any[]);
  const [freguesias, setFreguesias] = useState([] as any[]);
  const [massaagua, setMassaagua] = useState([] as any[]);
  const [nuts1, setNuts1] = useState([] as any[]);
  const [nuts2, setNuts2] = useState([] as any[]);
  const [nuts3, setNuts3] = useState([] as any[]);
  const [praias, setPraias] = useState([] as any[]);
  const [estados, setEstados] = useState([] as any[]);
  const [entidades, setEntidades] = useState([] as any[]);
  const [categorias, setCategorias] = useState([] as any[]);
  const [tiporecurso, setTiporecurso] = useState([] as any[]);
  const [tipoacesso, setTipoacesso] = useState([] as any[]);
  const [idioma, setIdioma] = useState([] as any[]);
  const [palavraschave, setPalavraschave] = useState([] as any[]);
  const [capitania, setCapitania] = useState([] as any[]);
  const [estadoCandidatura, setEstadoCandidatura] = useState([] as any[]);
  const [acaoEstado, setAcaoEstado] = useState([] as any[]);
  const [acaoPlaneamento1, setAcaoPlaneamento1] = useState([] as any[]);
  const [acaoPlaneamento2, setAcaoPlaneamento2] = useState([] as any[]);
  const [acaoPlaneamento3, setAcaoPlaneamento3] = useState([] as any[]);
  const [acaoPlaneamento4, setAcaoPlaneamento4] = useState([] as any[]);
  const [componenteAcao, setComponenteAcao] = useState([] as any[]);
  const [naturezaAcao, setNaturezaAcao] = useState([] as any[]);
  const [designacaoIntervencao, setDesignacao] = useState([] as any[]);
  const [designacaoAcao, setDesignacaoAcao] = useState([] as any[]);
  const [intComponente, setIntComponente] = useState([] as any[]);
  const [intIndicador, setIntIndicador] = useState([] as any[]);
  const [codigoIntervencao, setCodigo] = useState([] as any[]);
  const [tipoEngenharia, setTipoEngenharia] = useState([] as any[]);
  const [tipoPlaneamento, setTipoPlaneamento] = useState([] as any[]);
  const [instrumentoPlaneamento, setInstrumentoPlaneamento] = useState([] as any[]);
  const [deposicaoLocal1, setDeposicaoLocal1] = useState([] as any[]);
  const [deposicaoLocal2, setDeposicaoLocal2] = useState([] as any[]);
  const [deposicaoObjetivo1, setDeposicaoObjetivo1] = useState([] as any[]);
  const [deposicaoObjetivo2, setDeposicaoObjetivo2] = useState([] as any[]);
  const [granulametriaSedimentos, setGranulametriaSedimentos] = useState([] as any[]);
  const [mancha1, setMancha1] = useState([] as any[]);
  const [mancha2, setMancha2] = useState([] as any[]);
  const [metodoDeposicao, setMetodoDeposicao] = useState([] as any[]);
  const [metotodoDragagem, setMetotodoDragagem] = useState([] as any[]);
  const [mobilizacaoEstado, setMobilizacaoEstado] = useState([] as any[]);
  const [mobilizacaoFuncoes, setMobilizacaoFuncoes] = useState([] as any[]);
  const [qualidadeSedimentos, setQualidadeSedimentos] = useState([] as any[]);
  const [tipologiaMob, setTipologiaMob] = useState([] as any[]);
  const [estadoIntervencao, setEstadoIntervencao] = useState([] as any[]);
  const [instrumentoFinanciamento, setInstrumentoFinanciamento] = useState([] as any[]);
  const [procContratacao, setProcContratacao] = useState([] as any[]);
  const [codigoCandidatura, setCodigoCandidatura] = useState([] as any[]);

  const [prioridade, setPrioridade] = useState([] as any[]);
  const [prioridadePalXXI, setPrioridadePalXXI] = useState([] as any[]);
  const [tip1, setTip1] = useState([] as any[]);
  const [tip2, setTip2] = useState([] as any[]);
  const [tip3, setTip3] = useState([] as any[]);
  const [fontesDadosVus, setFontesDadosVus] = useState([] as any[]);
  const [tiposVus, setTiposVus] = useState([] as any[]);
  const [vus, setVus] = useState([] as any[]);
  const [agDecisoes, setAgDecisoes] = useState([] as any[]);
  const [agEstados, setAgEstados] = useState([] as any[]);
  const [agTipoPretensoes, setAgTipoPretensoes] = useState([] as any[]);
  const [moEstados, setMoEstados] = useState([] as any[]);
  const [modelosSubtipos, setModelosSubtipos] = useState([] as any[]);
  const [modelosTipos, setModelosTipos] = useState([] as any[]);
  const [status, setStatus] = useState([] as any[]);



  const fillArhs = () => {
    if (sessionStorage.getItem("arhs")) {
      setArhs(JSON.parse(decode(sessionStorage.getItem("arhs") ?? "")));
      fillPraias();
    } else {
      getArhs().then((result) => {
        if (result.length === 0) { return; }
        sessionStorage.setItem("arhs", encode(JSON.stringify(result)));
        setArhs(result);
        fillPraias();
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillConcelhos = () => {
    if (sessionStorage.getItem("concelhos")) {
      setConcelhos(JSON.parse(decode(sessionStorage.getItem("concelhos") ?? "")));
      fillFreguesias();
    } else {
      getConcelhos().then((result) => {
        if (result.length === 0) { return; }
        sessionStorage.setItem("concelhos", encode(JSON.stringify(result)));
        setConcelhos(result);
        fillFreguesias();
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillDistritos = (distrito: any = undefined) => {
    if (sessionStorage.getItem("distritos")) {
      setDistritos(JSON.parse(decode(sessionStorage.getItem("distritos") ?? "")));
      fillConcelhos();
    } else {
      getDistritos().then((result) => {
        if (result.length === 0) { return; }
        sessionStorage.setItem("distritos", encode(JSON.stringify(result)));
        setDistritos(result);
        fillConcelhos();
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillFreguesias = () => {
    if (sessionStorage.getItem("freguesias")) {
      setFreguesias(JSON.parse(decode(sessionStorage.getItem("freguesias") ?? "")));
      fillArhs();
    } else {
      getFreguesias().then((result: any[]) => {
        if (result.length === 0) { return; }
        sessionStorage.setItem("freguesias", encode(JSON.stringify(result)));
        setFreguesias(result);
        fillArhs();
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillMassaAgua = () => {
    if (sessionStorage.getItem("massaagua")) {
      setMassaagua(JSON.parse(decode(sessionStorage.getItem("massaagua") ?? "")));
      fillCapitania();
    } else {
      getMassaAgua().then((result) => {
        if (result.length === 0) { return; }
        sessionStorage.setItem("massaagua", encode(JSON.stringify(result)));
        setMassaagua(result);
        fillCapitania();
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillNuts1 = () => {
    if (sessionStorage.getItem("nuts1")) {
      setNuts1(JSON.parse(decode(sessionStorage.getItem("nuts1") ?? "")));
      fillNuts2();
    } else {
      getNuts1().then((result) => {
        if (result.length === 0) { return; }
        sessionStorage.setItem("nuts1", encode(JSON.stringify(result)));
        setNuts1(result);
        fillNuts2();
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillNuts2 = () => {
    if (sessionStorage.getItem("nuts2")) {
      setNuts2(JSON.parse(decode(sessionStorage.getItem("nuts2") ?? "")));
      fillNuts3();
    } else {
      getNuts2().then((result) => {
        if (result.length === 0) { return; }
        sessionStorage.setItem("nuts2", encode(JSON.stringify(result)));
        setNuts2(result);
        fillNuts3();
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillNuts3 = () => {
    if (sessionStorage.getItem("nuts3")) {
      setNuts3(JSON.parse(decode(sessionStorage.getItem("nuts3") ?? "")));
    } else {
      getNuts3().then((result) => {
        if (result.length === 0) { return; }
        sessionStorage.setItem("nuts3", encode(JSON.stringify(result)));
        setNuts3(result);
      }).catch(error => {
        handleError(error);
      })
    }
    fillTipoEntidades();

  };

  const fillPraias = () => {
    if (sessionStorage.getItem("praias")) {

      const praias = JSON.parse(decode(sessionStorage.getItem("praias") ?? ""));
      setPraias(praias);

      if (praias.length === 0) {
        setPraias([
          { id: 0, nome: 'Selecione' }
        ]);
      }

      fillEstado();
    } else {
      getPraias().then((result) => {
        if (result.length === 0) {
          setPraias([
            { id: 0, nome: 'Selecione' }
          ]);
          return;
        }
        sessionStorage.setItem("praias", encode(JSON.stringify(result)));
        setPraias(result);
        fillEstado();
      }).catch(error => {
        handleError(error);
        setPraias([
          { id: 0, nome: 'Selecione' }
        ]);
      })
    }
  };

  const fillEstado = () => {
    if (sessionStorage.getItem("estados")) {
      setEstados(JSON.parse(decode(sessionStorage.getItem("estados") ?? "")));
      fillMassaAgua();
    } else {
      getEstado().then((result) => {
        if (result.length === 0) { return; }
        sessionStorage.setItem("estados", encode(JSON.stringify(result)));
        setEstados(result);
        fillMassaAgua();
      }).catch(error => {
        handleError(error);
      })
    }
  }

  const fillEntidades = () => {
    if (sessionStorage.getItem("entidades")) {

      const entidades = JSON.parse(decode(sessionStorage.getItem("entidades") ?? ""));
      setEntidades(entidades);

      if (entidades.length === 0) {
        setEntidades([
          { id: 0, nome: 'Selecione' }
        ]);
      }

      setEntidades(preventPropsNullValues(entidades, "nome"))
      fillNuts1();
    } else {
      getEntidades().then((result) => {
        if (result.length === 0) {
          setEntidades([
            { id: 0, nome: 'Selecione' }
          ]);
          return;
        }
        sessionStorage.setItem("entidades", encode(JSON.stringify(result)));
        setEntidades(result);
        setEntidades(preventPropsNullValues(entidades, "nome"))
        fillNuts1();
      }).catch(error => {
        handleError(error);
        setEntidades([
          { id: 0, nome: 'Selecione' }
        ]);
      })
    }
  }

  const fillCategoria = () => {
    if (sessionStorage.getItem("categorias")) {
      setCategorias(JSON.parse(decode(sessionStorage.getItem("categorias") ?? "")));
      fillEntidades();
    } else {
      getCategoria().then((result) => {
        if (result.length === 0) { return; }
        sessionStorage.setItem("categorias", encode(JSON.stringify(result)));
        setCategorias(result);
        fillEntidades();
      }).catch(error => {
        handleError(error);
      })
    }
  }

  const fillTipoRecurso = () => {
    if (sessionStorage.getItem("tiporecurso")) {
      setTiporecurso(JSON.parse(decode(sessionStorage.getItem("tiporecurso") ?? "")));
      fillCategoria();
    } else {
      getTipoRecurso().then((result) => {
        if (result.length === 0) { return; }
        sessionStorage.setItem("tiporecurso", encode(JSON.stringify(result)));
        setTiporecurso(result);
        fillCategoria();
      }).catch(error => {
        handleError(error);
      })
    }
  }

  const fillTipoAcesso = () => {
    const userObj = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? '');

    if (sessionStorage.getItem("tipoacesso")) {
      setTipoacesso(JSON.parse(decode(sessionStorage.getItem("tipoacesso") ?? "")));
      fillTipoRecurso();
    } else {
      getTipoAcesso(userObj?.user?.id).then((result) => {
        if (result.length === 0) { return; }
        sessionStorage.setItem("tipoacesso", encode(JSON.stringify(result)));
        setTipoacesso(result);
        fillTipoRecurso();
      }).catch(error => {
        handleError(error);
      })
    }
  }

  const fillIdiomas = () => {
    if (sessionStorage.getItem("idiomas")) {
      setIdioma(JSON.parse(decode(sessionStorage.getItem("idiomas") ?? "")));
      fillTipoAcesso();
    } else {
      getIdiomas().then((result) => {
        if (result.length === 0) { return; }
        sessionStorage.setItem("idiomas", encode(JSON.stringify(result)));
        setIdioma(result);
        fillTipoAcesso();
      }).catch(error => {
        handleError(error);
      })
    }
  }

  const fillPalavrasChave = () => {
    if (sessionStorage.getItem("palavraschave")) {
      setPalavraschave(JSON.parse(decode(sessionStorage.getItem("palavraschave") ?? "")));
      fillIdiomas();
    } else {
      getPalavrasChave().then((result) => {
        if (result.length === 0) { return; }
        sessionStorage.setItem("palavraschave", encode(JSON.stringify(result)));
        setPalavraschave(result);
        fillIdiomas();
      }).catch(error => {
        handleError(error);
      })
    }
  }

  const fillCapitania = () => {
    if (sessionStorage.getItem("capitanias")) {
      setCapitania(JSON.parse(decode(sessionStorage.getItem("capitanias") ?? "")));
      fillPalavrasChave();
    } else {
      getCapitania().then((result) => {
        if (result.length === 0) { return; }
        sessionStorage.setItem("capitanias", encode(JSON.stringify(result)));
        setCapitania(result);
        fillPalavrasChave();
      }).catch(error => {
        handleError(error);
      })
    }
  }

  const fillAcaoPlaneamento1 = () => {
    if (sessionStorage.getItem("acaoPlaneamento1")) {
      setAcaoPlaneamento1(JSON.parse(decode(sessionStorage.getItem("acaoPlaneamento1") ?? "")));
    } else {
      getAcaoPlaneamento1().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("acaoPlaneamento1", encode(JSON.stringify(result)));
        setAcaoPlaneamento1(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillAcaoPlaneamento2 = () => {
    if (sessionStorage.getItem("acaoPlaneamento2")) {
      setAcaoPlaneamento2(JSON.parse(decode(sessionStorage.getItem("acaoPlaneamento2") ?? "")));
    } else {
      getAcaoPlaneamento2().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("acaoPlaneamento2", encode(JSON.stringify(result)));
        setAcaoPlaneamento2(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillAcaoPlaneamento3 = () => {
    if (sessionStorage.getItem("acaoPlaneamento3")) {
      setAcaoPlaneamento3(JSON.parse(decode(sessionStorage.getItem("acaoPlaneamento3") ?? "")));
    } else {
      getAcaoPlaneamento3().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("acaoPlaneamento3", encode(JSON.stringify(result)));
        setAcaoPlaneamento3(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillAcaoPlaneamento4 = () => {
    if (sessionStorage.getItem("acaoPlaneamento4")) {
      setAcaoPlaneamento4(JSON.parse(decode(sessionStorage.getItem("acaoPlaneamento4") ?? "")));
    } else {
      getAcaoPlaneamento4().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("acaoPlaneamento4", encode(JSON.stringify(result)));
        setAcaoPlaneamento4(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };



  const fillTipoPlanemaneto = () => {
    if (sessionStorage.getItem("tipoPlaneamento")) {
      setTipoPlaneamento(JSON.parse(decode(sessionStorage.getItem("tipoPlaneamento") ?? "")));
    } else {
      getTipoPlaneamento().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("tipoPlaneamento", encode(JSON.stringify(result)));
        setTipoPlaneamento(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };


  const fillLocalReposicao1 = () => {
    if (sessionStorage.getItem("localReposicao1")) {

      const locaisReposicao1 = JSON.parse(decode(sessionStorage.getItem("localReposicao1") ?? ""));
      setDeposicaoLocal1(locaisReposicao1);

      if (locaisReposicao1.length === 0) {
        setDeposicaoLocal1([
          { id: 0, nome: 'Selecione' }
        ]);
      }

    } else {
      getDeposicaoLocal1().then((result) => {
        if (result.length === 0) {
          setDeposicaoLocal1([
            { id: 0, nome: 'Selecione' }
          ]);
          return;
        }
        sessionStorage.setItem("localReposicao1", encode(JSON.stringify(result)));
        setDeposicaoLocal1(result);
      }).catch(error => {
        handleError(error);
        setDeposicaoLocal1([
          { id: 0, nome: 'Selecione' }
        ]);
      })
    }
  };

  const fillLocalReposicao2 = () => {
    if (sessionStorage.getItem("localReposicao2")) {

      const locaisReposicao2 = JSON.parse(decode(sessionStorage.getItem("localReposicao2") ?? ""));
      setDeposicaoLocal2(locaisReposicao2);

      if (locaisReposicao2.length === 0) {
        setDeposicaoLocal2([
          { id: 0, nome: 'Selecione' }
        ]);
      }

    } else {
      getDeposicaoLocal2().then((result) => {
        if (result.length === 0) {
          setDeposicaoLocal2([
            { id: 0, nome: 'Selecione' }
          ]);
          return;
        }
        sessionStorage.setItem("localReposicao2", encode(JSON.stringify(result)));
        setDeposicaoLocal2(result);
      }).catch(error => {
        handleError(error);
        setDeposicaoLocal2([
          { id: 0, nome: 'Selecione' }
        ]);
      })
    }
  };

  const fillObjetivo1 = () => {
    if (sessionStorage.getItem("objetivo1")) {
      setDeposicaoObjetivo1(JSON.parse(decode(sessionStorage.getItem("objetivo1") ?? "")));
    } else {
      getDeposicaoObjetivoNivel1().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("objetivo1", encode(JSON.stringify(result)));
        setDeposicaoObjetivo1(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillObjetivo2 = () => {
    if (sessionStorage.getItem("objetivo2")) {
      setDeposicaoObjetivo2(JSON.parse(decode(sessionStorage.getItem("objetivo2") ?? "")));
    } else {
      getDeposicaoObjetivoNivel2().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("objetivo2", encode(JSON.stringify(result)));
        setDeposicaoObjetivo2(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillGranulametriaSedimentos = () => {
    if (sessionStorage.getItem("granulametriaSedimentos")) {
      setGranulametriaSedimentos(JSON.parse(decode(sessionStorage.getItem("granulametriaSedimentos") ?? "")));
    } else {
      getGranulametriaSedimentos().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("granulametriaSedimentos", encode(JSON.stringify(result)));
        setGranulametriaSedimentos(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillMancha1 = () => {
    if (sessionStorage.getItem("mancha1")) {
      setMancha1(JSON.parse(decode(sessionStorage.getItem("mancha1") ?? "")));
    } else {
      getManchaNivel1().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("mancha1", encode(JSON.stringify(result)));
        setMancha1(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillMancha2 = () => {
    if (sessionStorage.getItem("mancha2")) {
      setMancha2(JSON.parse(decode(sessionStorage.getItem("mancha2") ?? "")));
    } else {
      getManchaNivel2().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("mancha2", encode(JSON.stringify(result)));
        setMancha2(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillMetodoDeposicao = () => {
    if (sessionStorage.getItem("metodoDeposicao")) {
      setMetodoDeposicao(JSON.parse(decode(sessionStorage.getItem("metodoDeposicao") ?? "")));
    } else {
      getMobMetodoDeposicao().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("metodoDeposicao", encode(JSON.stringify(result)));
        setMetodoDeposicao(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillMetodoDragagem = () => {
    if (sessionStorage.getItem("metodoDragagem")) {
      setMetotodoDragagem(JSON.parse(decode(sessionStorage.getItem("metotodoDragagem") ?? "")));
    } else {
      getMobMetodoDragagem().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("metotodoDragagem", encode(JSON.stringify(result)));
        setMetotodoDragagem(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };


  const fillFuncoes = () => {
    if (sessionStorage.getItem("funcoes")) {
      setMobilizacaoFuncoes(JSON.parse(decode(sessionStorage.getItem("funcoes") ?? "")));
    } else {
      getFuncao().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("funcoes", encode(JSON.stringify(result)));
        setMobilizacaoFuncoes(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };



  const fillTipologiaMob = () => {
    if (sessionStorage.getItem("tipologia")) {
      setTipologiaMob(JSON.parse(decode(sessionStorage.getItem("tipologia") ?? "")));
    } else {
      getTipologiaMob().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("tipologia", encode(JSON.stringify(result)));
        setTipologiaMob(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillEstadoIntervencao = () => {
    if (sessionStorage.getItem("estadoIntervencao")) {
      setEstadoIntervencao(JSON.parse(decode(sessionStorage.getItem("estadoIntervencao") ?? "")));
    } else {
      getEstadoIntervencao().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("estadoIntervencao", encode(JSON.stringify(result)));
        setEstadoIntervencao(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillInstrumentoFinanciamento = () => {
    if (sessionStorage.getItem("instrumentoFinanciamento")) {
      setInstrumentoFinanciamento(JSON.parse(decode(sessionStorage.getItem("instrumentoFinanciamento") ?? "")));
    } else {
      getInstrumentoFinanciamento().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("instrumentoFinanciamento", encode(JSON.stringify(result)));
        setInstrumentoFinanciamento(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };

 
  const fillPrioridade = () => {
    if (sessionStorage.getItem("prioridade")) {
      setPrioridade(JSON.parse(decode(sessionStorage.getItem("prioridade") ?? "")));
    } else {
      getPrioridade().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("prioridade", encode(JSON.stringify(result)));
        setPrioridade(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };



  const fillFontesDadosVus = () => {
    if (sessionStorage.getItem("fontesDadosVus")) {
      setFontesDadosVus(JSON.parse(decode(sessionStorage.getItem("fontesDadosVus") ?? "")));
    } else {
      getFontesDadosVus().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("fontesDadosVus", encode(JSON.stringify(result)));
        setFontesDadosVus(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillTiposVus = () => {
    if (sessionStorage.getItem("tiposVus")) {
      setTiposVus(JSON.parse(decode(sessionStorage.getItem("tiposVus") ?? "")));
    } else {
      getTiposVus().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("tiposVus", encode(JSON.stringify(result)));
        setTiposVus(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillVus = () => {
    if (sessionStorage.getItem("vus")) {
      setVus(JSON.parse(decode(sessionStorage.getItem("vus") ?? "")));
    } else {
      getVus().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("vus", encode(JSON.stringify(result)));
        setVus(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };


 

  const fillTipoPretensoesAsync = () => {
    const item = sessionStorage.getItem("agTipoPretensoes") ?? undefined;
    if (item) {
      setAgTipoPretensoes(JSON.parse(decode(item)));
    } else {
      getAgTipoPretensoes().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("agTipoPretensoes", encode(JSON.stringify(result)));
        setAgTipoPretensoes(result);
      }).catch((error) => {
        handleError(error);
      })
    }
  };

  // const fillMoEstados = () => {
  //   if (sessionStorage.getItem("moEstados")) {

  //     const estados = JSON.parse(decode(sessionStorage.getItem("moEstados") ?? ""));
  //     setMoEstados(estados);

  //     if (estados.length === 0) {
  //       setMoEstados([
  //         { id: 0, nome: 'Selecione' }
  //       ]);
  //     }
  //   } else {
  //     getMoEstados().then((result) => {
  //       if (result.length === 0) {
  //         setMoEstados([
  //           { id: 0, nome: 'Selecione' }
  //         ]);
  //         return;
  //       }
  //       sessionStorage.setItem("moEstados", encode(JSON.stringify(result)));
  //       setMoEstados(result);
  //     }).catch(error => {
  //       handleError(error);
  //       setMoEstados([
  //         { id: 0, nome: 'Selecione' }
  //       ]);
  //     })
  //   }
  // };

  const fillModelosSubTipos = () => {
    const modelosSubtiposStored = sessionStorage.getItem("modelosSubtipos") ?? undefined;
    if (modelosSubtiposStored) {
      setModelosSubtipos(JSON.parse(decode(modelosSubtiposStored)));
    } else {
      getMoModeloSubTipos().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("modelosSubtipos", encode(JSON.stringify(result)));
        setModelosSubtipos(result);
      }).catch(error => {
        handleError(error);
      })
    }
  };

  const fillModelosTipos = () => {

    const modelosTiposStored = sessionStorage.getItem("modelosTipos") ?? undefined;
    if (modelosTiposStored) {
      setModelosTipos(JSON.parse(decode(modelosTiposStored)));
    } else {
      getMoModeloTipos().then((result) => {
        if (!result) { return; }
        sessionStorage.setItem("modelosTipos", encode(JSON.stringify(result)));
        setModelosTipos(result);
      }).catch((error) => {
        handleError(error);
      })
    }
    fillModelosSubTipos();
  };

  const fillStatus = () => {

    const listaStatus: Status[] = [
      { designacao: 'Ativo', valor: true },
      { designacao: 'Desativado', valor: false },
    ];
  
    setStatus(listaStatus);
  };

  return {
    condicionantesProcessos, fillCondicionantesProcessosAsync,
    estadosProcesso, fillEstadosProcessoAsync,
    fasesProcedimentoDelimitacao, fillFasesProcedimentoDelimitacaoAsync,
    localizacoesProcesso, fillLocalizacoesProcessosAsync,
    tiposAcaoJudicial, fillTiposAcaoJudicialAsync,
    tiposAquisicao, fillTiposAquisicaoAsync,
    tiposDecisaoFinal, fillTiposDecisaoFinalAsync,
    tiposDesafetacao, fillTiposDesafetacaoAsync,
    tiposIniciativa, fillTiposIniciativaAsync,
    tiposNotificacao, fillTiposNotificacaoAsync,
    tiposParcela, fillTiposParcelaProvaAsync,
    tiposPendencia, fillTiposPendenciaAsync,
    tiposSentenca, fillTiposSentencaAsync,
    tiposSituacaoNotificacao, fillTiposSituacaoNotificacaoAsync,
    validacoesProva, fillValidacoesProvaAsync,
    arhs, fillArhs,
    concelhos, fillConcelhos,
    distritos, fillDistritos,
    freguesias, fillFreguesias,
    massaagua, fillMassaAgua,
    nuts1, fillNuts1,
    nuts2, fillNuts2,
    nuts3, fillNuts3,
    praias, fillPraias,
    estados, fillEstado,
    entidades, fillEntidades,
    categorias, fillCategoria,
    tiporecurso, fillTipoRecurso,
    tipoacesso, fillTipoAcesso,
    idioma, fillIdiomas,
    palavraschave, fillPalavrasChave,
    capitania, fillCapitania,
    tipoEntidades, fillTipoEntidades,
    tipossProcesso, fillTiposProcessoAsync,
    tipoDeProcesso, fillUsTiposProcessoAsync,
    TiposUtilizacao, fillUsTiposUtilizacaoAsync,
    agEstados, fillAgEstadosAsync,
    agTipoPretensoes, fillTipoPretensoesAsync,
    // moEstados, fillMoEstados,
    status, fillStatus,
    estadoIntervencao, fillEstadoIntervencaoAsync,
    instrumentoFinanciamento, fillInstrumentoFinanciamentoAsync,
    tip1, fillTip1Async,
    tip2, fillTip2Async,
    tip3, fillTip3Async,
    prioridade, fillPrioridadeAsync,
    instrumentoPlaneamento, fillInstrumentoPlaneamentoAsync,
    planeamento1, fillPlaneamento1Async,
    planeamento2, fillPlaneamento2Async,
    planeamento3, fillPlaneamento3Async,
    acaoEstado, fillAcaoEstadoAsync,
    tipoEngenharia, fillTipoEngenhariaAsync,
    naturezaAcao, fillNaturezaAcaoAsync,
    componenteAcao, fillComponenteAcaoAsync,
    tipoPlaneamento, fillTipoPlanemanetoAsync,
    acaoPlaneamento1, fillAcaoPlaneamento1Async,
    acaoPlaneamento2, fillAcaoPlaneamento2Async,
    acaoPlaneamento3, fillAcaoPlaneamento3Async,
    acaoPlaneamento4, fillAcaoPlaneamento4Async,
    estadoCandidatura, fillEstadoCandidaturaAsync,
    mobilizacaoFuncoes, fillMobilizacaoFuncoesAsync,
    tipologiaMob, fillMobilizacaoTipologiaAsync,
    deposicaoLocal1, fillDeposicaoNivel1Async,
    deposicaoLocal2, fillDeposicaoNivel2Async,
    mobilizacaoEstado, fillMobilizacaoEstadoAsync,
    mancha1, fillMancha1,
    mancha2, fillMancha2,
    metotodoDragagem, fillMetodoDragagemAsync,
    metodoDeposicao, fillMetodoDeposicaoAsync,
    deposicaoObjetivo1, fillObjetivoDeposicao1Async,
    deposicaoObjetivo2, fillObjetivoDeposicao2Async,
    granulametriaSedimentos, fillGranulametriaSedimentosAsync,
    estadosVus, fillUsEstadoVusAsync,
    estadosTitulo, fillEstadosTituloAsync,
    agDecisoes, fillDecisoesAsync,
    agTema, fillAgTemaAsync,
    modelosTipos, fillModelosTiposAsync,
    modelosSubtipos, fillModelosSubTiposAsync,
    qualidadeSedimentos, fillQualidadeSedimentosAsync,
    vus, fillVusAsync,
    tiposVus, fillTiposVusAsync,
    fontesDadosVus, fillFontesDadosVusAsync,
    entidadeUser, fillEntidadeByUserAsync,
    tipoIncidencia, fillTipoIncidenciaAsync,
    designacaoIntervencao, fillDesignacaoIntervencaoAsync,
    codigoIntervencao, fillCodigoIntervencaoAsync,
    designacaoAcao, fillDesignacaoAcao,
    intComponente, fillIntComponenteAsync,
    intIndicador, fillIntIndicadorAsync,
    procContratacao, fillProcContratacaoAsync,
    codigoCandidatura, fillCodigoCandidaturaAsync,
    prioridadePalXXI, fillPrioridadePalXXIAsync,
    tipoTitulos, fillTipoTituloAsync,
    moEstados, fillMoEstadoAsync
  };
};


export const fillPrioridadePalXXIAsync = () => {
  if (sessionStorage.getItem("prioridadePalXXI")) {
    prioridadePalXXI = JSON.parse(decode(sessionStorage.getItem("prioridadePalXXI") ?? ""));
  } else {
    getPrioridadePalXXI().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("prioridadePalXXI", encode(JSON.stringify(result)));
      prioridadePalXXI = result;
    }).catch(error => {
      handleError(error);
    })
  }
}


export const fillCodigoCandidaturaAsync = () => {
  if (sessionStorage.getItem("codigoCandidatura")) {
    codigoCandidatura = JSON.parse(decode(sessionStorage.getItem("codigoCandidatura") ?? ""));
  } else {
    getCodigoCandidatura().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("codigoCandidatura", encode(JSON.stringify(result)));
      codigoCandidatura = result;
    }).catch(error => {
      handleError(error);
    })
  }
}


export const fillProcContratacaoAsync = () => {
  if (sessionStorage.getItem("procContratacao")) {
    procContratacao = JSON.parse(decode(sessionStorage.getItem("procContratacao") ?? ""));
  } else {
    getProcContratacao().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("procContratacao", encode(JSON.stringify(result)));
      procContratacao = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillDesignacaoAcao = () => {
  if (sessionStorage.getItem("designacaoAcao")) {
    designacaoAcao = JSON.parse(decode(sessionStorage.getItem("designacaoAcao") ?? ""));
  } else {
    getDesignacaoAcao().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("designacaoAcao", encode(JSON.stringify(result)));
      designacaoAcao = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillIntIndicadorAsync = () => {
  if (SessionStorageService.getItem("intIndicador")) {
    intIndicador = SessionStorageService.getItem("intIndicador") ;
  } else {
    getIntIndicador().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("intIndicador", result);
      intIndicador = result;
    }).catch(error => {
      handleError(error);
    })
  }
}



export const fillIntComponenteAsync = () => {
  if (sessionStorage.getItem("intComponente")) {
    intComponente = JSON.parse(decode(sessionStorage.getItem("intComponente") ?? ""));
  } else {
    getIntComponente().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("intComponente", encode(JSON.stringify(result)));
      intComponente = result;
    }).catch(error => {
      handleError(error);
    })
  }
}


export const fillDesignacaoIntervencaoAsync = () => {
  if (sessionStorage.getItem("designacaoIntervencao")) {
    designacaoIntervencao = JSON.parse(decode(sessionStorage.getItem("designacaoIntervencao") ?? ""));
  } else {
    getDesignacaoIntervencao().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("designacaoIntervencao", encode(JSON.stringify(result)));
      designacaoIntervencao = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillCodigoIntervencaoAsync = () => {
  if (sessionStorage.getItem("codigoIntervencao")) {
    codigoIntervencao = JSON.parse(decode(sessionStorage.getItem("codigoIntervencao") ?? ""));
  } else {
    getCodigoIntervencao().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("codigoIntervencao", encode(JSON.stringify(result)));
      codigoIntervencao = result;
    }).catch(error => {
      handleError(error);
    })
  }
}


export const fillTipoIncidenciaAsync = () => {
  if (sessionStorage.getItem("tipoIncidencia")) {
    tipoIncidencia = JSON.parse(decode(sessionStorage.getItem("tipoIncidencia") ?? ""));
  } else {
 getTipoIncidencia().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("tipoIncidencia", encode(JSON.stringify(result)));
      tipoIncidencia = result;
    }).catch(error => {
      handleError(error);
    })
  }

  console.log("tipoIncidencia")
  console.log(tipoIncidencia)
}

export const fillFontesDadosVusAsync = () => {
   if (sessionStorage.getItem("fontesDadosVus")) {
    fontesDadosVus = JSON.parse(decode(sessionStorage.getItem("fontesDadosVus") ?? ""));
  } else {
 getFontesDadosVus().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("fontesDadosVus", encode(JSON.stringify(result)));
      fontesDadosVus = result;
    }).catch(error => {
      handleError(error);
    })
  }
  };

export const fillTiposVusAsync = () => {
   if (sessionStorage.getItem("tiposVus")) {
    tiposVus = JSON.parse(decode(sessionStorage.getItem("tiposVus") ?? ""));
  } else {
 getTiposVus().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("tiposVus", encode(JSON.stringify(result)));
      tiposVus = result;
    }).catch(error => {
      handleError(error);
    })
  }
  };

export const fillVusAsync = () => {
   if (sessionStorage.getItem("vus")) {
    vus = JSON.parse(decode(sessionStorage.getItem("vus") ?? ""));
  } else {
 getVus().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("vus", encode(JSON.stringify(result)));
      vus = result;
    }).catch(error => {
      handleError(error);
    })
  }
  };

 export const fillQualidadeSedimentosAsync = () => {
   if (sessionStorage.getItem("qualidadeSedimentos")) {
    qualidadeSedimentos = JSON.parse(decode(sessionStorage.getItem("qualidadeSedimentos") ?? ""));
  } else {
 getQualidadeSedimentos().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("qualidadeSedimentos", encode(JSON.stringify(result)));
      qualidadeSedimentos = result;
    }).catch(error => {
      handleError(error);
    })
  }
  };

 export const fillAgEstadosAsync = () => {
     if (sessionStorage.getItem("agEstados")) {
    agEstados = JSON.parse(decode(sessionStorage.getItem("agEstados") ?? ""));
  } else {
 getAgEstados().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("agEstados", encode(JSON.stringify(result)));
      agEstados = result;
    }).catch(error => {
      handleError(error);
    })
  }
  };

  export const fillTipoPretensoesAsync = () => {
    const item = SessionStorageService.getItem("agTipoPretensoes") ?? undefined;
    if (item) {
      agTipoPretensoes = item;
    } else {
      getAgTipoPretensoes().then((result) => {
        SessionStorageService.setItem("agTipoPretensoes", result);
        agTipoPretensoes = item;
      }).catch((error) => {
        handleError(error);
      })
    }
  };

 export const fillModelosSubTiposAsync = () => {
   if (sessionStorage.getItem("agTema")) {
    modelosSubtipos = JSON.parse(decode(sessionStorage.getItem("agTema") ?? ""));
  } else {
 getMoModeloSubTipos().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("agTema", encode(JSON.stringify(result)));
      modelosSubtipos = result;
    }).catch(error => {
      handleError(error);
    })
  }
  }

 export const fillAgTemaAsync = () => {
   if (sessionStorage.getItem("agTema")) {
    agTema = JSON.parse(decode(sessionStorage.getItem("agTema") ?? ""));
  } else {
 GetAgTema().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("agTema", encode(JSON.stringify(result)));
      agTema = result;
    }).catch(error => {
      handleError(error);
    })
  }
  }

 export const fillDecisoesAsync = () => {
   if (sessionStorage.getItem("agDecisoes")) {
    agDecisoes = JSON.parse(decode(sessionStorage.getItem("agDecisoes") ?? ""));
  } else {
 getAgDecisoes().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("agDecisoes", encode(JSON.stringify(result)));
      agDecisoes = result;
    }).catch(error => {
      handleError(error);
    })
  }
  }


export const fillAgTipoPretensaosync = () => {
  if (sessionStorage.getItem("tipoPretensao")) {
    agTipoPretensoes = JSON.parse(decode(sessionStorage.getItem("tipoPretensao") ?? ""));
  } else {
 getAgTipoPretensoes().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("tipoPretensao", encode(JSON.stringify(result)));
      agTipoPretensoes = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillUsEstadoVusAsync = () => {
  if (sessionStorage.getItem("estadosVus")) {
    estadosVus = JSON.parse(decode(sessionStorage.getItem("estadosVus") ?? ""));
  } else {
 GetUsEstadoVuss().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("estadosVus", encode(JSON.stringify(result)));
      estadosVus = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillEstadosTituloAsync = () => {
  if (sessionStorage.getItem("estadosTitulo")) {
    estadosTitulo = JSON.parse(decode(sessionStorage.getItem("estadosTitulo") ?? ""));
  } else {
    GetUsEstadoTitulo().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("estadosTitulo", encode(JSON.stringify(result)));
      estadosTitulo = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillGranulametriaSedimentosAsync = () => {
  if (sessionStorage.getItem("granulametriaSedimentos")) {
    granulametriaSedimentos = JSON.parse(decode(sessionStorage.getItem("granulametriaSedimentos") ?? ""));
  } else {
 getGranulametriaSedimentos().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("granulametriaSedimentos", encode(JSON.stringify(result)));
      granulametriaSedimentos = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillObjetivoDeposicao1Async = () => {
  if (sessionStorage.getItem("objetivoDeposicao1")) {
    deposicaoObjetivo1 = JSON.parse(decode(sessionStorage.getItem("objetivoDeposicao1") ?? ""));
  } else {
 getDeposicaoObjetivoNivel1().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("objetivoDeposicao1", encode(JSON.stringify(result)));
      deposicaoObjetivo1 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillObjetivoDeposicao2Async = () => {
  if (sessionStorage.getItem("objetivoDeposicao2")) {
    deposicaoObjetivo2 = JSON.parse(decode(sessionStorage.getItem("objetivoDeposicao2") ?? ""));
  } else {
   getDeposicaoObjetivoNivel2().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("objetivoDeposicao2", encode(JSON.stringify(result)));
      deposicaoObjetivo2 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillMetodoDeposicaoAsync = () => {
  if (sessionStorage.getItem("metodoDeposicao")) {
    metodoDeposicao = JSON.parse(decode(sessionStorage.getItem("metodoDeposicao") ?? ""));
  } else {
   getMobMetodoDeposicao().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("metodoDeposicao", encode(JSON.stringify(result)));
      metodoDeposicao = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillMetodoDragagemAsync = () => {
  if (sessionStorage.getItem("metodoDragagem")) {
    metotodoDragagem = JSON.parse(decode(sessionStorage.getItem("metodoDragagem") ?? ""));
  } else {
   getMobMetodoDragagem().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("metodoDragagem", encode(JSON.stringify(result)));
      metotodoDragagem = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillMancha1Async = () => {
  if (sessionStorage.getItem("mancha1")) {
    mancha1 = JSON.parse(decode(sessionStorage.getItem("mancha1") ?? ""));
  } else {
   getManchaNivel1().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("mancha1", encode(JSON.stringify(result)));
      mancha1 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillMancha2Async = () => {
  if (sessionStorage.getItem("mancha2")) {
    mancha2 = JSON.parse(decode(sessionStorage.getItem("mancha2") ?? ""));
  } else {
   getManchaNivel2().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("mancha2", encode(JSON.stringify(result)));
      mancha2 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillMobilizacaoEstadoAsync = () => {
   const userObj = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? '');

  if (sessionStorage.getItem("mobilizacaoEstado")) {
    mobilizacaoEstado = JSON.parse(decode(sessionStorage.getItem("mobilizacaoEstado") ?? ""));
  } else {
   getMobilizacaoEstado(userObj?.user?.id).then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("mobilizacaoEstado", encode(JSON.stringify(result)));
      mobilizacaoEstado = result;
    }).catch(error => {
      handleError(error);
    })
  }
}
export const fillVzEstadoAsync = () => {
  const vz_estado_key ="vzEstado";
  if (sessionStorage.getItem(vz_estado_key)) {
    vzEstados = JSON.parse(decode(sessionStorage.getItem(vz_estado_key) ?? ""));
  } else {
   getVzEstado().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem(vz_estado_key, encode(JSON.stringify(result)));
      vzEstados = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillDeposicaoNivel1Async = () => {
  if (sessionStorage.getItem("deposicaoNivel1")) {
    deposicaoLocal1 = JSON.parse(decode(sessionStorage.getItem("deposicaoNivel1") ?? ""));
  } else {
   getDeposicaoLocal1().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("deposicaoNivel1", encode(JSON.stringify(result)));
      deposicaoLocal1 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillDeposicaoNivel2Async = () => {
  if (sessionStorage.getItem("deposicaoNivel2")) {
    deposicaoLocal2 = JSON.parse(decode(sessionStorage.getItem("deposicaoNivel2") ?? ""));
  } else {
   getDeposicaoLocal2().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("deposicaoNivel2", encode(JSON.stringify(result)));
      deposicaoLocal2 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillMobilizacaoTipologiaAsync = () => {
  if (sessionStorage.getItem("mobilizacaoTipologia")) {
    tipologiaMob = JSON.parse(decode(sessionStorage.getItem("mobilizacaoTipologia") ?? ""));
  } else {
   getMobilizacaoTipologia().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("mobilizacaoTipologia", encode(JSON.stringify(result)));
      tipologiaMob = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillMobilizacaoFuncoesAsync = () => {
  if (sessionStorage.getItem("mobilizacaoFuncao")) {
    mobilizacaoFuncoes = JSON.parse(decode(sessionStorage.getItem("mobilizacaoFuncao") ?? ""));
  } else {
   getMobilizacaoFuncoes().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("mobilizacaoFuncao", encode(JSON.stringify(result)));
      mobilizacaoFuncoes = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillEstadoCandidaturaAsync = () => {
  if (sessionStorage.getItem("estadoCandidatura")) {
    estadoCandidatura = JSON.parse(decode(sessionStorage.getItem("estadoCandidatura") ?? ""));
  } else {
    getEstadoCandidatura().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("estadoCandidatura", encode(JSON.stringify(result)));
      estadoCandidatura = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillAcaoPlaneamento4Async = () => {
  if (sessionStorage.getItem("acaoPlaneamento4")) {
    acaoPlaneamento4 = JSON.parse(decode(sessionStorage.getItem("acaoPlaneamento4") ?? ""));
  } else {
    getAcaoPlaneamento4().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("acaoPlaneamento4", encode(JSON.stringify(result)));
      acaoPlaneamento4 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillAcaoPlaneamento3Async = () => {
  if (sessionStorage.getItem("acaoPlaneamento3")) {
    acaoPlaneamento3 = JSON.parse(decode(sessionStorage.getItem("acaoPlaneamento3") ?? ""));
  } else {
    getAcaoPlaneamento3().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("acaoPlaneamento3", encode(JSON.stringify(result)));
      acaoPlaneamento3 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillAcaoPlaneamento2Async = () => {
  if (sessionStorage.getItem("acaoPlaneamento2")) {
    acaoPlaneamento2 = JSON.parse(decode(sessionStorage.getItem("acaoPlaneamento2") ?? ""));
  } else {
    getAcaoPlaneamento2().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("acaoPlaneamento2", encode(JSON.stringify(result)));
      acaoPlaneamento2 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillAcaoPlaneamento1Async = () => {
  if (sessionStorage.getItem("acaoPlaneamento1")) {
    acaoPlaneamento1 = JSON.parse(decode(sessionStorage.getItem("acaoPlaneamento1") ?? ""));
  } else {
    getAcaoPlaneamento1().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("acaoPlaneamento1", encode(JSON.stringify(result)));
      acaoPlaneamento1 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTipoPlanemanetoAsync = () => {
  if (sessionStorage.getItem("tipoPlaneamento")) {
    tipoPlaneamento = JSON.parse(decode(sessionStorage.getItem("tipoPlaneamento") ?? ""));
  } else {
    getTipoPlaneamento().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("tipoPlaneamento", encode(JSON.stringify(result)));
      tipoPlaneamento = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillComponenteAcaoAsync = () => {
  if (sessionStorage.getItem("componenteAcao")) {
    componenteAcao = JSON.parse(decode(sessionStorage.getItem("componenteAcao") ?? ""));
  } else {
    getComponenteAcao().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("componenteAcao", encode(JSON.stringify(result)));
      componenteAcao = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillNaturezaAcaoAsync = () => {
  if (sessionStorage.getItem("naturezaAcao")) {
    naturezaAcao = JSON.parse(decode(sessionStorage.getItem("naturezaAcao") ?? ""));
  } else {
    getNaturezaAcao().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("naturezaAcao", encode(JSON.stringify(result)));
      naturezaAcao = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTipoEngenhariaAsync = () => {
  if (sessionStorage.getItem("tipoEngenharia")) {
    tipoEngenharia = JSON.parse(decode(sessionStorage.getItem("tipoEngenharia") ?? ""));
  } else {
    getTipEngenharia().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("tipoEngenharia", encode(JSON.stringify(result)));
      tipoEngenharia = result;
    }).catch(error => {
      handleError(error);
    })
  }
}


export const fillAcaoEstadoAsync = () => {
   const userObj = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? '');

  if (sessionStorage.getItem("acaoEstado")) {
    acaoEstado = JSON.parse(decode(sessionStorage.getItem("acaoEstado") ?? ""));
  } else {
    getAcaoEstado(userObj?.user?.id).then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("acaoEstado", encode(JSON.stringify(result)));
      acaoEstado = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillMoEstadoAsync = () => {
  if (sessionStorage.getItem("moEstado")) {
    moEstados = JSON.parse(decode(sessionStorage.getItem("moEstado") ?? ""));
  } else {
    getMoEstado().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("moEstado", encode(JSON.stringify(result)));
      moEstados = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillEaEstadoAsync = () => {
  if (sessionStorage.getItem("eaEstado")) {
    eaEstado = JSON.parse(decode(sessionStorage.getItem("eaEstado") ?? ""));
  } else {
    getEaEstado().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("eaEstado", encode(JSON.stringify(result)));
      eaEstado = result;
    }).catch(error => {
      handleError(error);
    })
  }
}


export const fillPlaneamento3Async = () => {
  if (SessionStorageService.getItem("planeamento3")) {
    planeamento3 = SessionStorageService.getItem("planeamento3");
  } else {
    getPlaneamento3().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("planeamento3", result);
      planeamento3 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillPlaneamento2Async = () => {
  if (SessionStorageService.getItem("planeamento2")) {
    planeamento2 = SessionStorageService.getItem("planeamento2");
  } else {
    getPlaneamento2().then((result) => {
      if (!result) { return; }
      SessionStorageService.setItem("planeamento2", result);
      planeamento2 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillPlaneamento1Async = () => {
  if (sessionStorage.getItem("planeamento1")) {
    planeamento1 = JSON.parse(decode(sessionStorage.getItem("planeamento1") ?? ""));
  } else {
    getPlaneamento1().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("planeamento1", encode(JSON.stringify(result)));
      planeamento1 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillInstrumentoPlaneamentoAsync = () => {
  if (sessionStorage.getItem("instrumentoPlaneamento")) {
    instrumentoPlaneamento = JSON.parse(decode(sessionStorage.getItem("instrumentoPlaneamento") ?? ""));
  } else {
    getInstrumentoPlaneamento().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("instrumentoPlaneamento", encode(JSON.stringify(result)));
      instrumentoPlaneamento = result;
    }).catch(error => {
      handleError(error);
    })
  }
}


export const fillPrioridadeAsync = () => {
  if (sessionStorage.getItem("prioridade")) {
    prioridade = JSON.parse(decode(sessionStorage.getItem("prioridade") ?? ""));
  } else {
    getPrioridade().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("prioridade", encode(JSON.stringify(result)));
      prioridade = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTip3Async = () => {
  if (sessionStorage.getItem("tipologiaNivel3")) {
    tip3 = JSON.parse(decode(sessionStorage.getItem("tipologiaNivel3") ?? ""));
  } else {
    getTipNivel3().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("tipologiaNivel3", encode(JSON.stringify(result)));
      tip3 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTip2Async = () => {
  if (sessionStorage.getItem("tipologiaNivel2")) {
    tip2 = JSON.parse(decode(sessionStorage.getItem("tipologiaNivel2") ?? ""));
  } else {
    getTipNivel2().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("tipologiaNivel2", encode(JSON.stringify(result)));
      tip2 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTip1Async = () => {
  if (sessionStorage.getItem("tipologiaNivel1")) {
    tip1 = JSON.parse(decode(sessionStorage.getItem("tipologiaNivel1") ?? ""));
  } else {
    getTipNivel1().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("tipologiaNivel1", encode(JSON.stringify(result)));
      tip1 = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillInstrumentoFinanciamentoAsync = () => {
  if (sessionStorage.getItem("instrumentoFinanciamento")) {
    instrumentoFinanciamento = JSON.parse(decode(sessionStorage.getItem("instrumentoFinanciamento") ?? ""));
  } else {
    getInstrumentoFinanciamento().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("instrumentoFinanciamento", encode(JSON.stringify(result)));
      instrumentoFinanciamento = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillValidacoesProva = () => {
  if (sessionStorage.getItem("validacoesProva")) {
    validacoesProva = JSON.parse(decode(sessionStorage.getItem("validacoesProva") ?? ""));
  } else {
    getValidacoesProva().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("validacoesProva", encode(JSON.stringify(result)));
      validacoesProva = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillStatusLocal = () => {
  const listaStatus: Status[] = [
    { designacao: 'Ativo', valor: true },
    { designacao: 'Desativado', valor: false },
  ];

  statusLocal = listaStatus;
}

export const fillTiposPendencia = () => {
  if (sessionStorage.getItem("tiposPendencia")) {
    tiposPendencia = JSON.parse(decode(sessionStorage.getItem("tiposPendencia") ?? ""));
  } else {
    getTiposPendencia().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("tiposPendencia", encode(JSON.stringify(result)));
      tiposPendencia = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillEstadosVus = () => {
  if (sessionStorage.getItem("estadosVus")) {
    estadosVus = JSON.parse(decode(sessionStorage.getItem("estadosVus") ?? ""));
  } else {
    getEstadosVus().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("estadosVus", encode(JSON.stringify(result)));
      estadosVus = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillEstadosTitulo = () => {
  if (sessionStorage.getItem("estadosTitulo")) {
    estadosTitulo = JSON.parse(decode(sessionStorage.getItem("estadosTitulo") ?? ""));
  } else {
    getEstadosTitulo().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("estadosTitulo", encode(JSON.stringify(result)));
      estadosTitulo = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

export const fillTiposComponenteVus = () => {
  if (sessionStorage.getItem("tiposComponenteVus")) {
    tiposComponenteVus = JSON.parse(decode(sessionStorage.getItem("tiposComponenteVus") ?? ""));
  } else {
    getTiposComponenteVus().then((result) => {
      if (!result) { return; }
      sessionStorage.setItem("tiposComponenteVus", encode(JSON.stringify(result)));
      tiposComponenteVus = result;
    }).catch(error => {
      handleError(error);
    })
  }
}

const fillSearchLimit = () => {
  GetSearchLimit().then((result) => {
    searchLimit = result;
  });
}

export const fillCombosAuxiliares = () => {
  // if (!localStorage.getItem(AUTH_LOCALSTORAGE)) {
  //   setTimeout(() => {
  //     fillCombosAuxiliares();
  //   }, 1000);
  //   return;
  // }
  if (localStorage.getItem(AUTH_LOCALSTORAGE)) {
   fillSearchLimit();
   fillAllCombos();
  }
  // const interval = setInterval(() => {
  //   postMessage({ type: "showLoader" }, "*");
  //   //if (isAllCombosFilled()) {
  //   if (!sessionStorage.getItem("logged")) {
  //     sessionStorage.setItem("logged", "true");
  //     location.reload();
  //   }
  //   //postMessage({ type: "hideLoader" }, "*");
  //   clearInterval(interval);
  //   //}
  // }, 1000)
  // console.log('aqui');
}

const fillAllCombos = () => {
 postMessage({type: "showLoaderCenter"}, "*");
  getCombos().then(result => {
    fillDistritosAsync(result.distritos);
    fillConcelhosAsync(result.concelhos);
    fillFreguesiasAsync(result.freguesias);
    fillMassaAguaAsync(result.massasAgua);
    fillTecnicosAsync(result.tecnicos);
    fillEntidadesAsync(result.entidades);
    fillNuts1Async(result.nuts1);
    fillNuts2Async(result.nuts2);
    fillNuts3Async(result.nuts3);
    fillArhsAsync(result.arhs);
    fillPraiasAsync(result.praias);
    postMessage({type: "hideLoaderCenter"}, "*");
  });
  fillMobilizacaoEstadoAsync();
  fillCodigoCandidaturaAsync();
  fillProcContratacaoAsync();
  fillDesignacaoIntervencaoAsync();
  fillCodigoIntervencaoAsync();
  fillDesignacaoAcao()
  fillIntComponenteAsync();
  fillIntIndicadorAsync();
  fillTipoTituloAsync();
  fillUsTiposUtilizacaoAsync();
  fillEntidadeByUserAsync();
  fillCapitaniaAsync();
  fillDhPareceres();
  fillDhTipoDominioAsync();
  fillDhRppAntesAsync();
  fillDhRppDepoisAsync();
  fillDhRecursoAsync();
  fillDhDeferimentoAsync();
  fillDhTipoLinhaAsync();
  fillDhProcessosMarcacoesAsync();
  fillEstadoAsync();
  fillAgEstadosAsync();
  fillAgTipoPretensaosync();
  fillIntTipoMobilizacaoAsync();
  fillModelosTiposAsync();
  fillTipoRecursoAsync();
//   fillCategoriaAsync();fe
//   fillIdiomasAsync();
//   fillArhsAsync();
  
  fillTipoAcessoAsync();
//   fillValidacoesProva();
//   fillTiposPendencia();
  fillPalavrasChaveAsync();
//   fillEstadosVus();
//   fillTiposComponenteVus();
//   fillTipoEntidades();
  fillTiposProcessoAsync();
  fillLocalizacoesProcessosAsync ();
   fillEstadosProcessoAsync();
//   fillTiposNotificacaoAsync();
  fillTiposSituacaoNotificacaoAsync();
  fillFasesProcedimentoDelimitacaoAsync();
  fillTiposSentencaAsync();
  fillTiposDecisaoFinalAsync();
  fillValidacoesProvaAsync();
//   fillTiposParcelaProvaAsync();
  fillTiposPendenciaAsync();
  fillCondicionantesProcessosAsync();
  fillTiposAcaoJudicialAsync();
//   fillTiposDesafetacaoAsync();
   fillTiposAquisicaoAsync();
  fillTiposIniciativaAsync();
  fillEstadoIntervencaoAsync();
//   fillInstrumentoFinanciamentoAsync();
  fillTip1Async();
  fillTip2Async();
  fillTip3Async();
//   fillPrioridadeAsync();
//   fillInstrumentoPlaneamentoAsync();
  fillPlaneamento1Async();
  fillPlaneamento2Async();
  fillPlaneamento3Async();
  fillAcaoEstadoAsync();
  fillTipoEngenhariaAsync();
  fillNaturezaAcaoAsync();
  fillComponenteAcaoAsync();
  fillTipoPlanemanetoAsync();
//   fillAcaoPlaneamento1Async();
//   fillAcaoPlaneamento2Async();
//   fillAcaoPlaneamento3Async();
  fillAcaoPlaneamento4Async();
  fillEstadoCandidaturaAsync();
  fillMobilizacaoFuncoesAsync();
  fillMobilizacaoTipologiaAsync();
  fillTipoIncidenciaAsync();
   fillDeposicaoNivel1Async();
   fillDeposicaoNivel2Async();
  fillMobilizacaoEstadoAsync();
//   fillVzEstadoAsync();
  fillMancha1Async();
  fillMancha2Async();
  fillMetodoDragagemAsync();
  fillMetodoDeposicaoAsync();
  fillObjetivoDeposicao1Async();
  fillObjetivoDeposicao2Async();
  fillGranulametriaSedimentosAsync();
  fillQualidadeSedimentosAsync();
  fillUsEstadoVusAsync();
//   fillDecisoesAsync();
//   fillDecisoesAsync();
//   fillAgTemaAsync();
//   fillModelosSubTiposAsync();
  fillEstadosOcorrenciaAsync();
  fillPrioridadePalXXIAsync()
  fillAgDecisoes();
  fillEaEstadoAsync();
  fillUsTiposProcessoAsync();
  fillEstadosTituloAsync();
  fillMoEstadoAsync();
}
const handleError = (error: unknown) => {
  console.log({ error });  //TODO custom error handling for combos
}

export const handleGenericError = (error: any, message = 'Não foi possivel efetuar esta operação') => {
    if (error?.response?.status == PERMISSION_ERROR_STATUS_CODE || 
      error?.response?.status == NOT_AUTHORIZED_ERROR_STATUS_CODE) {
      postMessage({ type: "errorMsg", value: { message: "Não tem permissões para essa funcionalidade" } }, "*");
    } else {
      postMessage(
        {
          type: 'errorMsg',
          value: { message:  message},
        },
        '*'
      )
}
}

//export const fillCapitanias = () => {
// if (sessionStorage.getItem("capitanias")) {
//  capitanias = JSON.parse(decode(sessionStorage.getItem("capitanias") ?? ""));
//  postMessage({ type: "hideLoader" }, "*");
//} else {
//  getCapitania().then((result) => {
// if (!result) { return; }
//  sessionStorage.setItem("capitanias", encode(JSON.stringify(result)));
//  capitanias = result;
//  postMessage({ type: "hideLoader" }, "*");
//})
//}
//}

export const setCoordenadasSelected = (coordenadas?: any) => {
  coordenadasSelected = coordenadas;
}

export const setCoordenadasPoligono = (value?: string) => {
  coordenadasPoligono = value;
}

export const setEaResultado = (value : boolean) => {
  SessionStorageService.setItem("eaResultado", value);
}

export const getEaResultado = () => {
  return SessionStorageService.getItem("eaResultado");
}

export const setEaCheckedPoligno = (value : any) => {
  SessionStorageService.setItem("checkedPolignoAnalise", value);
}

export const getEaCheckedPoligno = () => {
  return SessionStorageService.getItem("checkedPolignoAnalise");
}

export const setCoordenadasLinhaSelected = (value?: string) => {
  coordenadasLinhaSelected = value;
}

export const setValidateGeomEA = (value?: boolean) => {
  SessionStorageService.setItem("validateGeomEA", value);
}

export const setFlatCordinatesEA = (value?: boolean) => {
  SessionStorageService.setItem("checkedFlatCordinatesEA", value);
}

export const setFlatCordinatesApoioEA = (value?: boolean) => {
  SessionStorageService.setItem("checkedFlatCordinatesApoioEA", value);
}

export const setEaRegistoAnalise = (value : any) => {
  SessionStorageService.setItem("eaRegistoAnalise", value);
}

export const getEaRegistoAnalise = () => {
  return SessionStorageService.getItem("eaRegistoAnalise");
}

export const getFlatCoordinatesEA = () => {
  return SessionStorageService.getItem("checkedFlatCordinatesEA");
}

export const getFlatCoordinatesApoioEA = () => {
  return SessionStorageService.getItem("checkedFlatCordinatesApoioEA");
}

export const getValidateGeomEA = () => {
  return SessionStorageService.getItem("validateGeomEA");
}

//  VALIDAÇÃO COMPONENTE DE ANALISE - EA
export const setCheckedRetirada = (value?: boolean) => {
  SessionStorageService.setItem("checkedRetirada", value);
}

export const getCheckedRetirada = () => {
  return SessionStorageService.getItem("checkedRetirada");
}

export const setCheckedDefesa = (value?: boolean) => {
  SessionStorageService.setItem("checkedDefesa", value);
}

export const getCheckedDefesa = () => {
  return SessionStorageService.getItem("checkedDefesa");
}

export const setCheckedAdaptacao= (value?: boolean) => {
  SessionStorageService.setItem("checkedAdaptacao", value);
}

export const getCheckedAdaptacao = () => {
  return SessionStorageService.getItem("checkedAdaptacao");
}

export const setCheckedDefesaAdaptacao= (value?: boolean) => {
  SessionStorageService.setItem("checkedDefesaAdaptacao", value);
}

export const getCheckedDefesaAdaptacao = () => {
  return SessionStorageService.getItem("checkedDefesaAdaptacao");
}


export const setGeoPortalUrl = (value: string) => {
  geoPortalUrl = value;
}

export const setMenuItemSelected = (value: string) => {
  menuItemSelected = value;
}

export const setGeoPortalUser = (value: any) => {
  geoPortalUser = value;
  SessionStorageService.setItem("geoportalUser", value);
  localStorage.setItem("geoportalUser", encode(JSON.stringify(value)));
}

export function getGeoPortalUser() {
  if (!localStorage.getItem("geoportalUser")) {
    geoPortalUser = { username: USER_GUEST, password: PASS_GUEST }
    SessionStorageService.setItem("geoportalUser", { username: USER_GUEST, password: PASS_GUEST });
    localStorage.setItem("geoportalUser", encode(JSON.stringify({ username: USER_GUEST, password: PASS_GUEST })));
  } else {
    geoPortalUser = JSON.parse(decode(localStorage.getItem("geoportalUser")?? "")) //SessionStorageService.getItem("geoportalUser");
  }
  return geoPortalUser;
}


export const mapStore = create((set: (arg0: { url: any; }) => any) => ({
  url: "",
  setUrl: (imput: any) => set({ url: imput }),
}))

export const sendUserLogin = () => {
  const iframe: any = document.getElementById("iframeGeoPortal");
  iframe.contentWindow?.postMessage({
    type: "DoSiarlGeoPortalLogin",
    user: geoPortalUser
  }, "*");
  sessionStorage.setItem("userLoginSended", "true");
}

export const hasPermission = (permission: string) => {
  if (!localStorage.getItem(AUTH_LOCALSTORAGE)) {
    return false;
  }
  const objLogin = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? "");
  const roles: any[] = objLogin.user?.roles;

  for (let i = 0; i < roles?.length; i++) {
    const permissions: any[] = roles[i].permissions;
    for (let j = 0; j < permissions?.length; j++) {
      if (permissions[j].trim() == permission.trim()) {
        return true;
      }
    }
  }
  return false;
}

export const hasEntidade = (idEntidade: any) => {
  return objectEntidadeUser?.id == idEntidade
}

export const hasEntidadeByName = (nomeEntidade: any) => {
  return entidadeUser == nomeEntidade;
}

export function blobToBase64(blob: Blob): Promise<ArrayBuffer | string | null> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export async function blobToBase64Safe(blob: Blob): Promise<string> {
  const arrayBuffer = await blob.arrayBuffer();
  let binary = '';
  const bytes = new Uint8Array(arrayBuffer);

  const chunkSize = 0x8000;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode.apply(
      null,
      bytes.subarray(i, i + chunkSize) as unknown as number[]
    );
  }

  return btoa(binary); // apenas Base64 puro
}

export async function fillLocation(item: any) {
  let freguesiaSelectedItem;
  let nuts3SelectedItem;
  if (item.freguesia_cod) {
    freguesiaSelectedItem = await  getFreguesiaFromCode(item?.freguesia_cod);
  }
  if (item.nuts3_cod) {
    nuts3SelectedItem = await getNuts3FromCode(item?.nuts3_cod);
  }
  
    return {
      freguesia: freguesiaSelectedItem,
      concelho: freguesiaSelectedItem?.concelho,
      distrito: freguesiaSelectedItem?.distrito,
      nuts3: nuts3SelectedItem,
      nuts2: nuts3SelectedItem?.nuts2,
      nuts1: nuts3SelectedItem?.nuts1,
      capitania: item.capitania,
      massaAgua: item.massa_agua
    }
  
}




export function getVooDroneSelected() {
  return SessionStorageService.getItem("vooDrone");
}

export function setVooDroneSelected(value: any) {
  SessionStorageService.setItem("vooDrone", value);
}

export function getAcaoSelected() {
  return SessionStorageService.getItem("acao");
}
export function setAcaoSelected(value: any) {
  SessionStorageService.setItem("acao", value);
}

export function getIntervencaoSelected() {
  return SessionStorageService.getItem("intervencao");
}

export function setIntervencaoSelected(value: any) {
  SessionStorageService.setItem("intervencao", value);
}

export function getUsoSoloSelected() {
  return SessionStorageService.getItem("usoSolo");
}

export function setusoSoloSelected(value: any) {
  SessionStorageService.setItem("usoSolo", value);
}

export function getMobilizacaoSelected() {
  return SessionStorageService.getItem("mobilizacao");
}
export function getCandidaturaSelected() {
  return SessionStorageService.getItem("candidatura");
}
export function setCandidaturaSelected(value: any) {
  SessionStorageService.setItem("candidatura", value);
}
export function getCandidaturaAcaoSelected() {
  return SessionStorageService.getItem("candidaturaAcao");
}
export function setCandidaturaAcaoSelected(value: any) {
  SessionStorageService.setItem("candidaturaAcao", value);
}

export function setMobilizacaoSelected(value: any) {
  SessionStorageService.setItem("mobilizacao", value);
}
export function getProcessoSelected() {
  return SessionStorageService.getItem("processo");
}

export function setProcessoSelected(value: any) {
  SessionStorageService.setItem("processo", value);
}

export function clearProcesso() {
  SessionStorageService.removeItem("processo");
}

export function getOcorrenciaSelected() {
  return sessionStorage.getItem("ocorrencia") ? JSON.parse(sessionStorage.getItem("ocorrencia") ?? "{}") : undefined;
}

export function setOcorrenciaSelected(value: any) {
  if (value == undefined) {
    sessionStorage.removeItem("ocorrencia");
    return;
  }
  sessionStorage.setItem("ocorrencia", JSON.stringify(value));
}

export function getFotografiaObliquaSelected() {
  return JSON.parse(SessionStorageService.getItem("fotografiaObliqua") ?? "{}");
}

export function setFotografiaObliquaSelected(value: any) {
  SessionStorageService.setItem("fotografiaObliqua", JSON.stringify(value));
}

export function getEntidadeSelected() {
  return JSON.parse(SessionStorageService.getItem("entidade") ?? "{}");
}

export function setEntidadeSelected(value: any) {
  SessionStorageService.setItem("entidade", JSON.stringify(value));
}

export function getPretensaoSelected() {
  return sessionStorage.getItem("pretensao") ? JSON.parse(sessionStorage.getItem("pretensao") ?? "{}") : undefined;
}

export function setPretensaoSelected(value: any) {
  if (value == undefined) {
    sessionStorage.removeItem("pretensao");
    return;
  }
  sessionStorage.setItem("pretensao", JSON.stringify(value));
}

export function getDesconformidadeSelected() {
  return sessionStorage.getItem("desconformidade") ? JSON.parse(sessionStorage.getItem("desconformidade") ?? "{}") : undefined;
}

export function setDesconformidadeSelected(value: any) {
  if (value == undefined) {
    sessionStorage.removeItem("desconformidade");
    return;
  }
  sessionStorage.setItem("desconformidade", JSON.stringify(value));
}

export function getPatrimonioSelected() {
  return SessionStorageService.getItem("patrimonio") ? SessionStorageService.getItem("patrimonio") : undefined;
}

export function setPatrimonioSelected(value: any) {
  if (value == undefined) {
    SessionStorageService.removeItem("patrimonio");
    return;
  }
  SessionStorageService.setItem("patrimonio", value);
}

export function clearPatrimonio() {
  SessionStorageService.removeItem("patrimonio");
}

export function getDemarcacaoSelected() {
  return sessionStorage.getItem("demarcacao") ?
    JSON.parse(sessionStorage.getItem("demarcacao") ?? "{}") : undefined;
}

export function setDemarcacaoSelected(value: any) {
  if (value == undefined) {
    sessionStorage.removeItem("demarcacao");
    return;
  }
  sessionStorage.setItem("demarcacao", JSON.stringify(value));
}

export function clearIntervencao() {
  SessionStorageService.removeItem("intervencao");
}

export function clearFotoObliqua() {
  SessionStorageService.removeItem("fotografiaObliqua");
}

export function clearAcao() {
  SessionStorageService.removeItem("acao");
}

export function clearDemarcacao() {
  SessionStorageService.removeItem("demarcacao");
}

export function clearEntidade() {
  SessionStorageService.removeItem("entidade");
}


export function getkmlDetalheSelected(): any {
  return SessionStorageService.getItem("kmlDetalhe");
}

export function setkmlDetalheSelected(value: any) {
  SessionStorageService.setItem("kmlDetalhe", value);
}
export function getVooDronePathSelected(): any {
  return SessionStorageService.getItem("VooDronePath");
}

export function setVooDronePathSelected(value: any) {
  SessionStorageService.setItem("VooDronePath", value);
}

export function getDocumentoSelected(): any {
  return SessionStorageService.getItem("documento");
}

export function setDocumentoSelected(value: any) {
  SessionStorageService.setItem("documento", value);
}

export function clearDocumento() {
  SessionStorageService.removeItem("documento");
}

export function getModeloSelected(): any {
  return SessionStorageService.getItem("modelo");
}

export function setModeloSelected(value: any) {
  SessionStorageService.setItem("modelo", value);
}

export function clearModelo() {
  SessionStorageService.removeItem("modelo");
}

export function setCurrentMapId(value: string) {
  sessionStorage.setItem("mapid", value);
}

export function getCurrentMapId() {
  return sessionStorage.getItem("mapid");
}

export function setSharedMap(value: any) {
  sessionStorage.setItem("sharedMap", JSON.stringify(value));
}

export function setIsEditingOcorrencia(value: any) {
  SessionStorageService.setItem("isEditingOcorrencia", value);
}

export function getIsEditingOcorrencia() {
  if (!SessionStorageService.getItem("isEditingOcorrencia")) {
    SessionStorageService.setItem("isEditingOcorrencia", false);
    return false;
  }
  return SessionStorageService.getItem("isEditingOcorrencia");
}

export function setFotoIndex (value: any) {
  fotoIndex = value;
}

export function getSharedMap() {
  return JSON.parse(sessionStorage.getItem("sharedMap") ?? '{}');
}

export const getExtensionFromPath = (filePath: string) => {

  if (!filePath) {
    throw new Error('Caminho do arquivo não pode ser vazio.');
  }

  const parts = filePath.split('/');
  const fileNameWithExtension = parts[parts.length - 1];

  if (!fileNameWithExtension.includes('.')) {
    throw new Error('Caminho do arquivo não contém uma extensão válida.');
  }

  const fileNameParts = fileNameWithExtension.split('.');
  const fileExtension = fileNameParts[fileNameParts.length - 1];

  if (!fileExtension) {
    throw new Error('Extensão do arquivo não encontrada.');
  }

  return fileExtension;
};

export const isStrongPassword = (password: string): boolean => {
  
  if (!/^(?=.*[A-Z])(?=.*[!@#$%^&*/\-_*+])[A-Za-z\d!@#$%^&*/\-_*+]{8,}$/.test(password)) {
    return false;
  }
  return true;
}
export const getFlatCoordinatesFromObj = (value: any) => {
  let polygonString = ''
  const values: any[] = value
  values?.forEach((value, index) => {
    if (index % 2 == 0) {
      polygonString += value + ' '
    } else {
      polygonString += value + ','
    }
  })
  polygonString = polygonString.substring(0, polygonString.length - 1)
  return polygonString
}


export const parseNumber = (value: any) => {
  const num = Number.parseFloat(value);
  return isNaN(num) ? 0 : num;
};

export const formatCurrency_normalise = (value: number | string | undefined) => {
  if (value === undefined || value === null) return undefined;

  const number = normalizeNumber(value); //typeof value === "string" ? parseFloat(value) : value;

  return new Intl.NumberFormat("pt-PT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
};

export const formatCurrency = (value: number | string | undefined) => {
  if (value === undefined || value === null) return undefined;

  const number = typeof value === "string" ? parseFloat(value) : value;

  return new Intl.NumberFormat("pt-PT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
};


export const normalizeNumber = (value: string | number | null | undefined): number => {
  if (value === undefined || value === null) return 0;  
  if (typeof value === "number") return value;
  
  const normalized = value.replace(/\./g, "").replace(",", ".");
  return Number.parseFloat(normalized) || 0;  
};
 
export const allCombosString = [
  "freguesias",
  "concelhos",
  "distritos",
  "arhs",
  "praias",


  "estados",
  "massaagua",
  "capitania",
  "entidades",
  "palavraschave",

  "tipoacesso",
  "tiporecurso",
  "categorias",
  "nuts1",
  "nuts2",

  "nuts3",
  "modelosTipos",
  "modelosSubtipos",
  "tipoEntidades",
  "tiposProcesso",


  "localizacoesProcesso",
  "fasesProcedimentoDelimitacao",
  "validacoesProva",
  "tiposParcela",
  "tiposSentenca",

  "tiposDecisaoFinal",
  "estadosProcesso",
  "tiposPendencia",
  "tiposNotificacao",
  "tiposSituacaoNotificacao",

  "condicionantesProcessos",
  "tiposAcaoJudicial",
  "tiposDesafetacao",
  "tiposAquisicao",
  "tiposIniciativa",

  "agDecisoes",
  "agTipoPretensoes",
  "tiposVus",
  "estadosVus",
  "estadosTitulo",
  "tiposComponenteVus",

  "fontesDadosVus",
  "vus",
  "agEstados",
  "moEstados",
  "idioma",
  "idiomas",
  "capitanias",

  "mobilizacaoFuncoes", 
  "acaoPlaneamento1",
  "acaoPlaneamento2",
  "acaoPlaneamento3",
  "acaoPlaneamento4",

  "mobilizacaoEstado",
  "prioridade",
  "acaoEstado",
  "instrumentoFinanciamento",
  "instrumentoPlaneamento",

  "estadoIntervencao",
  "planeamento1",
  "planeamento2",
  "planeamento3",
  "tipoPlaneamento",

  "tipoEngenharia",
  "naturezaAcao",
  "tip1",
  "tip2",
  "tip3",

  "componenteAcao",
  "tipologiaMob",
  "granulametriaSedimentos",
  "qualidadeSedimentos",
  "deposicaoObjetivo1",

  "deposicaoObjetivo2",
  "metodoDeposicao",
  "deposicaoLocal1",
  "deposicaoLocal2",
  "metotodoDragagem",

  "mancha1",
  "mancha2",

  "geoportalUser",
  "criterioEntidades",
];

export  const updateColumnsGrid = (columns: any, columnsGrid: any, setColumnsGrid: any) => {
  const coluns: any[] = columns.columns;
  let columnsGridLocal: any[] = columnsGrid.columns.slice();
  coluns.forEach((item: any) => {
    for(let i = 0; i < columnsGridLocal.length; i++) {
      if (columnsGridLocal[i].title == item.title) {
        columnsGridLocal[i].show = item.show;
      }
    }
  })
  columnsGridLocal = columnsGridLocal.filter(x => x.show);
  coluns.forEach((item: any) => {
    if (item.show && !columnsGridLocal.find(x => x.title == item.title)) {
      columnsGridLocal.push(item);
    }
    
  })
  setColumnsGrid({columns: columnsGridLocal});
}

export const isJsonString = (value: string) => {
  try {
    JSON.parse(value)
  } catch (error) {
    return false
  }

  return true
}
